// Auto-generated (Emergent LLM key): verification / finder-flow UI strings.
export const VERIF_I18N = {
"en": {
"vq.title": "Identity verification questions",
"vq.optional": "(optional — recommended)",
"vq.hint": "Ask 1 to 3 questions that only the true owner knows the answer to (e.g. color of a detail, contents, distinguishing mark). Never visible publicly.",
"vq.hintDeposit": "Ask 1 to 3 questions that only the true owner knows the answer to (e.g. color of a detail, contents, distinguishing mark). They will be used to validate a claim. Never visible publicly.",
"vq.question": "Question {n}",
"vq.optionalSuffix": "(optional)",
"vq.noneWarning": "No question added. We recommend providing at least one to secure the return and avoid false claims.",
"vq.registryRef": "Reference to validate the owner during the return — never visible publicly.",
"vq.answersIntroQ": "To avoid false claims, answer the questions below (color of a detail, brand, contents, distinguishing mark). Your answers are visible neither publicly nor on the listing.",
"vq.answersIntroFree": "To avoid false claims, describe 2 to 3 precise characteristics of the item (color of a detail, brand, contents, distinguishing mark). Your answers are visible neither publicly nor on the listing.",
"vq.characteristic": "Characteristic {n}",
"vq.answerPh": "Your answer…",
"vq.charPh": "E.g. scratch on the lower-right corner",
"vq.sending": "Sending…",
"vq.submit": "Submit my verification",
"vq.cancel": "Cancel",
"vq.rejectTitle": "Reject the claim",
"vq.rejectHint": "Briefly indicate why. This reason will be sent to the claimant.",
"vq.rejectNoMatch": "The answers do not match",
"vq.rejectVague": "Description too vague",
"vq.rejectReturned": "Item already returned",
"vq.rejectOther": "Other",
"vq.rejectOtherPh": "Specify the reason…",
"vq.rejectConfirm": "Confirm rejection",
"fd.title": "Warning",
"fd.text": "Any false statement may result in the suspension or even the permanent deletion of your Findloop account.",
"fd.continue": "I understand, continue",
"fd.cancel": "Cancel",
"fr.already": "You have already reported finding this item. Your report is being processed.",
"fr.photoLabel": "Photo of the found item",
"fr.photoHint": "It will be shown to the owner so they can confirm that it is indeed their item.",
"fr.photoError": "Add a photo of the found item.",
"fr.isItYours": "Is this your item?",
"fr.isItYoursHint": "A finder sent the photo below. If it is your item, describe a few distinguishing features to prove it.",
"fr.yesMine": "Yes, it's my item",
"fr.notMine": "This is not my item",
"fr.stPending": "The finder is checking your description",
"fr.stRejected": "Characteristics not confirmed",
"fr.stApproved": "Confirmed by the finder",
"fr.proveTitle": "Prove that it's your item",
"fr.proveHint": "Describe characteristics that only the owner knows: color, brand, engraving, contents, visible defect… The finder will confirm whether they match.",
"fr.sent": "Description sent to the finder. You will be notified of their response.",
"fr.approvedTitle": "The finder confirmed your description",
"fr.approvedHint": "Pay the recovery fee to get their contact details.",
"fr.photoAlt": "Photo sent by the finder",
"fd.textFound": "Any false statement constitutes fraud and may lead to legal proceedings under the laws in force in your country.",
"rp.otherPh": "Specify the reason for the report…",
"rp.otherRequired": "Specify the reason for the report.",
"mc.cancelClaim": "Cancel my claim",
"mc.cancelClaimDone": "Your claim has been canceled.",
"mc.cancelClaimConfirm": "Are you sure you want to cancel your claim?",
"mc.confirm": "Confirm",
"mc.cancel": "Cancel",
"mc.stDeposited": "Deposited",
"mc.stClaimed": "Claimed",
"mc.stReturned": "Returned",
"mc.progress": "Progress"
},
"es": {
"vq.title": "Preguntas de verificación de identidad",
"vq.optional": "(opcional — recomendado)",
"vq.hint": "Haz de 1 a 3 preguntas cuya respuesta solo conozca el verdadero propietario (p. ej., el color de un detalle, el contenido, una señal particular). Nunca visibles públicamente.",
"vq.hintDeposit": "Haz de 1 a 3 preguntas cuya respuesta solo conozca el verdadero propietario (p. ej., el color de un detalle, el contenido, una señal particular). Servirán para validar una reclamación. Nunca visibles públicamente.",
"vq.question": "Pregunta {n}",
"vq.optionalSuffix": "(opcional)",
"vq.noneWarning": "No se ha añadido ninguna pregunta. Te recomendamos indicar al menos una para asegurar la devolución y evitar reclamaciones falsas.",
"vq.registryRef": "Referencia para validar al propietario durante la devolución — nunca visible públicamente.",
"vq.answersIntroQ": "Para evitar reclamaciones falsas, responde a las preguntas de abajo (color de un detalle, marca, contenido, señal particular). Tus respuestas no son visibles ni públicamente ni en el anuncio.",
"vq.answersIntroFree": "Para evitar reclamaciones falsas, describe de 2 a 3 características precisas del objeto (color de un detalle, marca, contenido, señal particular). Tus respuestas no son visibles ni públicamente ni en el anuncio.",
"vq.characteristic": "Característica {n}",
"vq.answerPh": "Tu respuesta…",
"vq.charPh": "Ej. arañazo en la esquina inferior derecha",
"vq.sending": "Enviando…",
"vq.submit": "Enviar mi verificación",
"vq.cancel": "Cancelar",
"vq.rejectTitle": "Rechazar la reclamación",
"vq.rejectHint": "Indica brevemente por qué. Este motivo se transmitirá al reclamante.",
"vq.rejectNoMatch": "Las respuestas no coinciden",
"vq.rejectVague": "Descripción demasiado vaga",
"vq.rejectReturned": "Objeto ya devuelto",
"vq.rejectOther": "Otro",
"vq.rejectOtherPh": "Especifica el motivo…",
"vq.rejectConfirm": "Confirmar el rechazo",
"fd.title": "Atención",
"fd.text": "Cualquier declaración falsa podrá conllevar la suspensión, o incluso la eliminación definitiva de tu cuenta de findloop.",
"fd.continue": "Entiendo, continuar",
"fd.cancel": "Cancelar",
"fr.already": "Ya has indicado que encontraste este objeto. Tu declaración está siendo procesada.",
"fr.photoLabel": "Foto del objeto encontrado",
"fr.photoHint": "Se mostrará al propietario para que confirme que efectivamente se trata de su objeto.",
"fr.photoError": "Añade una foto del objeto encontrado.",
"fr.isItYours": "¿Es realmente tu objeto?",
"fr.isItYoursHint": "Una persona que lo encontró ha enviado la foto de abajo. Si es tu objeto, describe algunos rasgos distintivos para demostrarlo.",
"fr.yesMine": "Sí, es mi objeto",
"fr.notMine": "No es mi objeto",
"fr.stPending": "La persona que lo encontró está verificando tu descripción",
"fr.stRejected": "Características no confirmadas",
"fr.stApproved": "Confirmado por la persona que lo encontró",
"fr.proveTitle": "Demuestra que es tu objeto",
"fr.proveHint": "Describe características que solo conoce el propietario: color, marca, grabado, contenido, defecto visible… La persona que lo encontró confirmará si coinciden.",
"fr.sent": "Descripción enviada a la persona que lo encontró. Se te notificará su respuesta.",
"fr.approvedTitle": "La persona que lo encontró ha confirmado tu descripción",
"fr.approvedHint": "Paga los gastos de recuperación para obtener sus datos de contacto.",
"fr.photoAlt": "Foto enviada por la persona que lo encontró",
"fd.textFound": "Toda declaración falsa constituye un fraude susceptible de acciones judiciales conforme a la legislación vigente en su país.",
"rp.otherPh": "Precise el motivo del reporte…",
"rp.otherRequired": "Precise el motivo del reporte.",
"mc.cancelClaim": "Cancelar mi reclamación",
"mc.cancelClaimDone": "Su reclamación ha sido cancelada.",
"mc.cancelClaimConfirm": "¿Está seguro de que desea cancelar su reclamación?",
"mc.confirm": "Confirmar",
"mc.cancel": "Cancelar",
"mc.stDeposited": "Depositado",
"mc.stClaimed": "Reclamado",
"mc.stReturned": "Devuelto",
"mc.progress": "Progreso"
},
"de": {
"vq.title": "Fragen zur Identitätsprüfung",
"vq.optional": "(optional — empfohlen)",
"vq.hint": "Stellen Sie 1 bis 3 Fragen, deren Antwort nur der echte Eigentümer kennt (z. B. Farbe eines Details, Inhalt, besonderes Merkmal). Niemals öffentlich sichtbar.",
"vq.hintDeposit": "Stellen Sie 1 bis 3 Fragen, deren Antwort nur der echte Eigentümer kennt (z. B. Farbe eines Details, Inhalt, besonderes Merkmal). Sie dienen dazu, einen Anspruch zu prüfen. Niemals öffentlich sichtbar.",
"vq.question": "Frage {n}",
"vq.optionalSuffix": "(optional)",
"vq.noneWarning": "Es wurde keine Frage hinzugefügt. Wir empfehlen Ihnen, mindestens eine anzugeben, um die Rückgabe zu sichern und falsche Ansprüche zu vermeiden.",
"vq.registryRef": "Referenz zur Bestätigung des Eigentümers bei der Rückgabe — niemals öffentlich sichtbar.",
"vq.answersIntroQ": "Um falsche Ansprüche zu vermeiden, beantworten Sie die untenstehenden Fragen (Farbe eines Details, Marke, Inhalt, besonderes Merkmal). Ihre Antworten sind weder öffentlich noch in der Anzeige sichtbar.",
"vq.answersIntroFree": "Um falsche Ansprüche zu vermeiden, beschreiben Sie 2 bis 3 genaue Merkmale des Gegenstands (Farbe eines Details, Marke, Inhalt, besonderes Merkmal). Ihre Antworten sind weder öffentlich noch in der Anzeige sichtbar.",
"vq.characteristic": "Merkmal {n}",
"vq.answerPh": "Ihre Antwort…",
"vq.charPh": "Z. B. Kratzer an der unteren rechten Ecke",
"vq.sending": "Wird gesendet…",
"vq.submit": "Meine Verifizierung senden",
"vq.cancel": "Abbrechen",
"vq.rejectTitle": "Anspruch ablehnen",
"vq.rejectHint": "Geben Sie kurz den Grund an. Dieser Grund wird dem Anspruchsteller übermittelt.",
"vq.rejectNoMatch": "Die Antworten stimmen nicht überein",
"vq.rejectVague": "Beschreibung zu vage",
"vq.rejectReturned": "Gegenstand bereits zurückgegeben",
"vq.rejectOther": "Andere",
"vq.rejectOtherPh": "Grund angeben…",
"vq.rejectConfirm": "Ablehnung bestätigen",
"fd.title": "Achtung",
"fd.text": "Jede falsche Angabe kann zur Sperrung oder sogar zur dauerhaften Löschung Ihres findloop-Kontos führen.",
"fd.continue": "Ich verstehe, fortfahren",
"fd.cancel": "Abbrechen",
"fr.already": "Sie haben bereits gemeldet, dass Sie diesen Gegenstand gefunden haben. Ihre Meldung wird derzeit bearbeitet.",
"fr.photoLabel": "Foto des gefundenen Gegenstands",
"fr.photoHint": "Es wird dem Eigentümer gezeigt, damit er bestätigen kann, dass es sich tatsächlich um seinen Gegenstand handelt.",
"fr.photoError": "Fügen Sie ein Foto des gefundenen Gegenstands hinzu.",
"fr.isItYours": "Ist das Ihr Gegenstand?",
"fr.isItYoursHint": "Ein Finder hat das untenstehende Foto gesendet. Wenn es Ihr Gegenstand ist, beschreiben Sie einige besondere Merkmale, um es zu beweisen.",
"fr.yesMine": "Ja, das ist mein Gegenstand",
"fr.notMine": "Das ist nicht mein Gegenstand",
"fr.stPending": "Der Finder prüft Ihre Beschreibung",
"fr.stRejected": "Merkmale nicht bestätigt",
"fr.stApproved": "Vom Finder bestätigt",
"fr.proveTitle": "Beweisen Sie, dass es Ihr Gegenstand ist",
"fr.proveHint": "Beschreiben Sie Merkmale, die nur der Eigentümer kennt: Farbe, Marke, Gravur, Inhalt, sichtbarer Mangel… Der Finder wird bestätigen, ob sie übereinstimmen.",
"fr.sent": "Beschreibung an den Finder gesendet. Sie werden über seine Antwort benachrichtigt.",
"fr.approvedTitle": "Der Finder hat Ihre Beschreibung bestätigt",
"fr.approvedHint": "Bezahlen Sie die Abholgebühren, um seine Kontaktdaten zu erhalten.",
"fr.photoAlt": "Vom Finder gesendetes Foto",
"fd.textFound": "Jede falsche Angabe stellt einen Betrug dar und kann gemäß der in Ihrem Land geltenden Gesetzgebung strafrechtlich verfolgt werden.",
"rp.otherPh": "Bitte geben Sie den Grund der Meldung an…",
"rp.otherRequired": "Bitte geben Sie den Grund der Meldung an.",
"mc.cancelClaim": "Meine Reklamation stornieren",
"mc.cancelClaimDone": "Ihre Reklamation wurde storniert.",
"mc.cancelClaimConfirm": "Möchten Sie Ihren Anspruch wirklich stornieren?",
"mc.confirm": "Bestätigen",
"mc.cancel": "Abbrechen",
"mc.stDeposited": "Abgegeben",
"mc.stClaimed": "Beansprucht",
"mc.stReturned": "Zurückgegeben",
"mc.progress": "Fortschritt"
},
"it": {
"vq.title": "Domande di verifica dell'identità",
"vq.optional": "(opzionale — consigliato)",
"vq.hint": "Fai da 1 a 3 domande di cui solo il vero proprietario conosce la risposta (es. colore di un dettaglio, contenuto, segno particolare). Mai visibili pubblicamente.",
"vq.hintDeposit": "Fai da 1 a 3 domande di cui solo il vero proprietario conosce la risposta (es. colore di un dettaglio, contenuto, segno particolare). Serviranno a convalidare una richiesta. Mai visibili pubblicamente.",
"vq.question": "Domanda {n}",
"vq.optionalSuffix": "(facoltativa)",
"vq.noneWarning": "Nessuna domanda aggiunta. Ti consigliamo di inserirne almeno una per rendere più sicura la restituzione ed evitare richieste false.",
"vq.registryRef": "Riferimento per convalidare il proprietario al momento della restituzione — mai visibile pubblicamente.",
"vq.answersIntroQ": "Per evitare richieste false, rispondi alle domande qui sotto (colore di un dettaglio, marca, contenuto, segno particolare). Le tue risposte non sono visibili né pubblicamente né nell'annuncio.",
"vq.answersIntroFree": "Per evitare richieste false, descrivi da 2 a 3 caratteristiche precise dell'oggetto (colore di un dettaglio, marca, contenuto, segno particolare). Le tue risposte non sono visibili né pubblicamente né nell'annuncio.",
"vq.characteristic": "Caratteristica {n}",
"vq.answerPh": "La tua risposta…",
"vq.charPh": "Es. graffio sull'angolo inferiore destro",
"vq.sending": "Invio…",
"vq.submit": "Invia la mia verifica",
"vq.cancel": "Annulla",
"vq.rejectTitle": "Rifiuta la richiesta",
"vq.rejectHint": "Indica brevemente il motivo. Questo motivo sarà trasmesso al richiedente.",
"vq.rejectNoMatch": "Le risposte non corrispondono",
"vq.rejectVague": "Descrizione troppo vaga",
"vq.rejectReturned": "Oggetto già restituito",
"vq.rejectOther": "Altro",
"vq.rejectOtherPh": "Specifica il motivo…",
"vq.rejectConfirm": "Conferma il rifiuto",
"fd.title": "Attenzione",
"fd.text": "Qualsiasi falsa dichiarazione potrà comportare la sospensione, o persino la cancellazione definitiva del tuo account findloop.",
"fd.continue": "Ho capito, continua",
"fd.cancel": "Annulla",
"fr.already": "Hai già segnalato di aver trovato questo oggetto. La tua segnalazione è in fase di elaborazione.",
"fr.photoLabel": "Foto dell'oggetto trovato",
"fr.photoHint": "Sarà mostrata al proprietario affinché confermi che si tratta effettivamente del suo oggetto.",
"fr.photoError": "Aggiungi una foto dell'oggetto trovato.",
"fr.isItYours": "È davvero il tuo oggetto?",
"fr.isItYoursHint": "Una persona che l'ha trovato ha inviato la foto qui sotto. Se è il tuo oggetto, descrivi alcuni segni particolari per dimostrarlo.",
"fr.yesMine": "Sì, è il mio oggetto",
"fr.notMine": "Non è il mio oggetto",
"fr.stPending": "Chi l'ha trovato sta verificando la tua descrizione",
"fr.stRejected": "Caratteristiche non confermate",
"fr.stApproved": "Confermato da chi l'ha trovato",
"fr.proveTitle": "Dimostra che è il tuo oggetto",
"fr.proveHint": "Descrivi caratteristiche che solo il proprietario conosce: colore, marca, incisione, contenuto, difetto visibile… Chi l'ha trovato confermerà se corrispondono.",
"fr.sent": "Descrizione inviata a chi l'ha trovato. Riceverai una notifica della sua risposta.",
"fr.approvedTitle": "Chi l'ha trovato ha confermato la tua descrizione",
"fr.approvedHint": "Paga le spese di recupero per ottenere i suoi recapiti.",
"fr.photoAlt": "Foto inviata da chi l'ha trovato",
"fd.textFound": "Qualsiasi falsa dichiarazione costituisce una frode perseguibile legalmente ai sensi della normativa vigente nel tuo Paese.",
"rp.otherPh": "Specifica il motivo della segnalazione…",
"rp.otherRequired": "Specifica il motivo della segnalazione.",
"mc.cancelClaim": "Annulla la mia richiesta",
"mc.cancelClaimDone": "La tua richiesta è stata annullata.",
"mc.cancelClaimConfirm": "Sei sicuro di voler annullare la tua richiesta?",
"mc.confirm": "Conferma",
"mc.cancel": "Annulla",
"mc.stDeposited": "Depositato",
"mc.stClaimed": "Richiesto",
"mc.stReturned": "Restituito",
"mc.progress": "Avanzamento"
},
"pt": {
"vq.title": "Perguntas de verificação de identidade",
"vq.optional": "(opcional — recomendado)",
"vq.hint": "Faça de 1 a 3 perguntas cuja resposta só o verdadeiro proprietário conhece (ex.: cor de um detalhe, conteúdo, sinal particular). Nunca visíveis publicamente.",
"vq.hintDeposit": "Faça de 1 a 3 perguntas cuja resposta só o verdadeiro proprietário conhece (ex.: cor de um detalhe, conteúdo, sinal particular). Elas servirão para validar uma reclamação. Nunca visíveis publicamente.",
"vq.question": "Pergunta {n}",
"vq.optionalSuffix": "(opcional)",
"vq.noneWarning": "Nenhuma pergunta adicionada. Recomendamos que indique pelo menos uma para proteger a devolução e evitar reclamações falsas.",
"vq.registryRef": "Referência para validar o proprietário durante a devolução — nunca visível publicamente.",
"vq.answersIntroQ": "Para evitar reclamações falsas, responda às perguntas abaixo (cor de um detalhe, marca, conteúdo, sinal particular). As suas respostas não são visíveis nem publicamente, nem no anúncio.",
"vq.answersIntroFree": "Para evitar reclamações falsas, descreva de 2 a 3 características precisas do objeto (cor de um detalhe, marca, conteúdo, sinal particular). As suas respostas não são visíveis nem publicamente, nem no anúncio.",
"vq.characteristic": "Característica {n}",
"vq.answerPh": "A sua resposta…",
"vq.charPh": "Ex.: risco no canto inferior direito",
"vq.sending": "A enviar…",
"vq.submit": "Enviar a minha verificação",
"vq.cancel": "Cancelar",
"vq.rejectTitle": "Rejeitar a reclamação",
"vq.rejectHint": "Indique brevemente o motivo. Este motivo será transmitido ao reclamante.",
"vq.rejectNoMatch": "As respostas não correspondem",
"vq.rejectVague": "Descrição demasiado vaga",
"vq.rejectReturned": "Objeto já devolvido",
"vq.rejectOther": "Outro",
"vq.rejectOtherPh": "Especifique o motivo…",
"vq.rejectConfirm": "Confirmar a rejeição",
"fd.title": "Atenção",
"fd.text": "Qualquer declaração falsa poderá resultar na suspensão, ou até na eliminação definitiva da sua conta findloop.",
"fd.continue": "Compreendo, continuar",
"fd.cancel": "Cancelar",
"fr.already": "Já indicou que encontrou este objeto. A sua declaração está em processamento.",
"fr.photoLabel": "Foto do objeto encontrado",
"fr.photoHint": "Ela será mostrada ao proprietário para que ele confirme que se trata realmente do seu objeto.",
"fr.photoError": "Adicione uma foto do objeto encontrado.",
"fr.isItYours": "É mesmo o seu objeto?",
"fr.isItYoursHint": "Uma pessoa que encontrou um objeto enviou a foto abaixo. Se for o seu objeto, descreva alguns sinais particulares para o provar.",
"fr.yesMine": "Sim, é o meu objeto",
"fr.notMine": "Não é o meu objeto",
"fr.stPending": "A pessoa que encontrou o objeto está a verificar a sua descrição",
"fr.stRejected": "Características não confirmadas",
"fr.stApproved": "Confirmado pela pessoa que encontrou o objeto",
"fr.proveTitle": "Prove que é o seu objeto",
"fr.proveHint": "Descreva características que só o proprietário conhece: cor, marca, gravação, conteúdo, defeito visível… A pessoa que encontrou o objeto confirmará se correspondem.",
"fr.sent": "Descrição enviada à pessoa que encontrou o objeto. Será notificado da resposta.",
"fr.approvedTitle": "A pessoa que encontrou o objeto confirmou a sua descrição",
"fr.approvedHint": "Pague os custos de recuperação para obter os seus contactos.",
"fr.photoAlt": "Foto enviada pela pessoa que encontrou o objeto",
"fd.textFound": "Qualquer declaração falsa constitui uma fraude passível de ação judicial nos termos da legislação em vigor no seu país.",
"rp.otherPh": "Especifique o motivo da denúncia…",
"rp.otherRequired": "Especifique o motivo da denúncia.",
"mc.cancelClaim": "Cancelar a minha reclamação",
"mc.cancelClaimDone": "A sua reclamação foi cancelada.",
"mc.cancelClaimConfirm": "Tem certeza de que deseja cancelar sua reclamação?",
"mc.confirm": "Confirmar",
"mc.cancel": "Cancelar",
"mc.stDeposited": "Depositado",
"mc.stClaimed": "Reclamado",
"mc.stReturned": "Devolvido",
"mc.progress": "Progresso"
},
"nl": {
"vq.title": "Identiteitsverificatievragen",
"vq.optional": "(optioneel — aanbevolen)",
"vq.hint": "Stel 1 tot 3 vragen waarvan alleen de echte eigenaar het antwoord kent (bijv. kleur van een detail, inhoud, bijzonder kenmerk). Nooit openbaar zichtbaar.",
"vq.hintDeposit": "Stel 1 tot 3 vragen waarvan alleen de echte eigenaar het antwoord kent (bijv. kleur van een detail, inhoud, bijzonder kenmerk). Ze zullen worden gebruikt om een claim te valideren. Nooit openbaar zichtbaar.",
"vq.question": "Vraag {n}",
"vq.optionalSuffix": "(optioneel)",
"vq.noneWarning": "Geen vraag toegevoegd. We raden u aan er minstens één in te vullen om de teruggave te beveiligen en valse claims te voorkomen.",
"vq.registryRef": "Referentie om de eigenaar te valideren bij de teruggave — nooit openbaar zichtbaar.",
"vq.answersIntroQ": "Om valse claims te voorkomen, beantwoord de onderstaande vragen (kleur van een detail, merk, inhoud, bijzonder kenmerk). Uw antwoorden zijn noch openbaar zichtbaar, noch op de advertentie.",
"vq.answersIntroFree": "Om valse claims te voorkomen, beschrijf 2 tot 3 precieze kenmerken van het voorwerp (kleur van een detail, merk, inhoud, bijzonder kenmerk). Uw antwoorden zijn noch openbaar zichtbaar, noch op de advertentie.",
"vq.characteristic": "Kenmerk {n}",
"vq.answerPh": "Uw antwoord…",
"vq.charPh": "Bijv. kras op de rechterbenedenhoek",
"vq.sending": "Verzenden…",
"vq.submit": "Mijn verificatie verzenden",
"vq.cancel": "Annuleren",
"vq.rejectTitle": "Claim afwijzen",
"vq.rejectHint": "Geef kort aan waarom. Deze reden wordt doorgestuurd naar de claimant.",
"vq.rejectNoMatch": "De antwoorden komen niet overeen",
"vq.rejectVague": "Beschrijving te vaag",
"vq.rejectReturned": "Voorwerp al teruggegeven",
"vq.rejectOther": "Anders",
"vq.rejectOtherPh": "Specificeer de reden…",
"vq.rejectConfirm": "Afwijzing bevestigen",
"fd.title": "Let op",
"fd.text": "Elke valse verklaring kan leiden tot opschorting of zelfs definitieve verwijdering van uw findloop-account.",
"fd.continue": "Ik begrijp het, doorgaan",
"fd.cancel": "Annuleren",
"fr.already": "U heeft al gemeld dat u dit voorwerp heeft gevonden. Uw melding wordt verwerkt.",
"fr.photoLabel": "Foto van het gevonden voorwerp",
"fr.photoHint": "Deze wordt aan de eigenaar getoond zodat die kan bevestigen dat het inderdaad zijn of haar voorwerp is.",
"fr.photoError": "Voeg een foto van het gevonden voorwerp toe.",
"fr.isItYours": "Is dit uw voorwerp?",
"fr.isItYoursHint": "Een vinder heeft onderstaande foto gestuurd. Als dit uw voorwerp is, beschrijf dan enkele bijzondere kenmerken om het te bewijzen.",
"fr.yesMine": "Ja, het is mijn voorwerp",
"fr.notMine": "Dit is niet mijn voorwerp",
"fr.stPending": "De vinder controleert uw beschrijving",
"fr.stRejected": "Kenmerken niet bevestigd",
"fr.stApproved": "Bevestigd door de vinder",
"fr.proveTitle": "Bewijs dat dit uw voorwerp is",
"fr.proveHint": "Beschrijf kenmerken die alleen de eigenaar kent: kleur, merk, gravure, inhoud, zichtbaar gebrek… De vinder zal bevestigen of ze overeenkomen.",
"fr.sent": "Beschrijving naar de vinder gestuurd. U krijgt een melding van zijn of haar antwoord.",
"fr.approvedTitle": "De vinder heeft uw beschrijving bevestigd",
"fr.approvedHint": "Betaal de ophaalkosten om zijn of haar contactgegevens te krijgen.",
"fr.photoAlt": "Foto gestuurd door de vinder",
"fd.textFound": "Elke valse verklaring vormt fraude en kan leiden tot gerechtelijke vervolging volgens de geldende wetgeving in uw land.",
"rp.otherPh": "Specificeer de reden van de melding…",
"rp.otherRequired": "Specificeer de reden van de melding.",
"mc.cancelClaim": "Mijn claim annuleren",
"mc.cancelClaimDone": "Uw claim is geannuleerd.",
"mc.cancelClaimConfirm": "Weet u zeker dat u uw claim wilt annuleren?",
"mc.confirm": "Bevestigen",
"mc.cancel": "Annuleren",
"mc.stDeposited": "Ingeleverd",
"mc.stClaimed": "Geclaimd",
"mc.stReturned": "Teruggegeven",
"mc.progress": "Voortgang"
},
"pl": {
"vq.title": "Pytania weryfikacji tożsamości",
"vq.optional": "(opcjonalne — zalecane)",
"vq.hint": "Zadaj od 1 do 3 pytań, na które odpowiedź zna tylko prawdziwy właściciel (np. kolor jakiegoś detalu, zawartość, znak szczególny). Nigdy nie są widoczne publicznie.",
"vq.hintDeposit": "Zadaj od 1 do 3 pytań, na które odpowiedź zna tylko prawdziwy właściciel (np. kolor jakiegoś detalu, zawartość, znak szczególny). Posłużą do zweryfikowania roszczenia. Nigdy nie są widoczne publicznie.",
"vq.question": "Pytanie {n}",
"vq.optionalSuffix": "(opcjonalne)",
"vq.noneWarning": "Nie dodano żadnego pytania. Zalecamy podanie przynajmniej jednego, aby zabezpieczyć zwrot i uniknąć fałszywych roszczeń.",
"vq.registryRef": "Odniesienie do potwierdzenia właściciela przy zwrocie — nigdy niewidoczne publicznie.",
"vq.answersIntroQ": "Aby uniknąć fałszywych roszczeń, odpowiedz na poniższe pytania (kolor detalu, marka, zawartość, znak szczególny). Twoje odpowiedzi nie są widoczne ani publicznie, ani w ogłoszeniu.",
"vq.answersIntroFree": "Aby uniknąć fałszywych roszczeń, opisz 2–3 precyzyjne cechy przedmiotu (kolor detalu, marka, zawartość, znak szczególny). Twoje odpowiedzi nie są widoczne ani publicznie, ani w ogłoszeniu.",
"vq.characteristic": "Cecha {n}",
"vq.answerPh": "Twoja odpowiedź…",
"vq.charPh": "Np. rysa w prawym dolnym rogu",
"vq.sending": "Wysyłanie…",
"vq.submit": "Wyślij moją weryfikację",
"vq.cancel": "Anuluj",
"vq.rejectTitle": "Odrzuć roszczenie",
"vq.rejectHint": "Krótko wskaż dlaczego. Ten powód zostanie przekazany zgłaszającemu.",
"vq.rejectNoMatch": "Odpowiedzi się nie zgadzają",
"vq.rejectVague": "Opis jest zbyt ogólny",
"vq.rejectReturned": "Przedmiot został już zwrócony",
"vq.rejectOther": "Inne",
"vq.rejectOtherPh": "Doprecyzuj powód…",
"vq.rejectConfirm": "Potwierdź odrzucenie",
"fd.title": "Uwaga",
"fd.text": "Każde fałszywe oświadczenie może skutkować zawieszeniem, a nawet trwałym usunięciem Twojego konta findloop.",
"fd.continue": "Rozumiem, kontynuuj",
"fd.cancel": "Anuluj",
"fr.already": "Masz już zgłoszenie znalezienia tego przedmiotu. Twoje zgłoszenie jest obecnie przetwarzane.",
"fr.photoLabel": "Zdjęcie znalezionego przedmiotu",
"fr.photoHint": "Zostanie pokazane właścicielowi, aby mógł potwierdzić, że to rzeczywiście jego przedmiot.",
"fr.photoError": "Dodaj zdjęcie znalezionego przedmiotu.",
"fr.isItYours": "Czy to na pewno Twój przedmiot?",
"fr.isItYoursHint": "Znalazca przesłał poniższe zdjęcie. Jeśli to Twój przedmiot, opisz kilka znaków szczególnych, aby to udowodnić.",
"fr.yesMine": "Tak, to mój przedmiot",
"fr.notMine": "To nie mój przedmiot",
"fr.stPending": "Znalazca sprawdza Twój opis",
"fr.stRejected": "Cechy nie zostały potwierdzone",
"fr.stApproved": "Potwierdzone przez znalazcę",
"fr.proveTitle": "Udowodnij, że to Twój przedmiot",
"fr.proveHint": "Opisz cechy, które zna tylko właściciel: kolor, marka, grawer, zawartość, widoczna wada… Znalazca potwierdzi, czy się zgadzają.",
"fr.sent": "Opis został wysłany do znalazcy. Otrzymasz powiadomienie o jego odpowiedzi.",
"fr.approvedTitle": "Znalazca potwierdził Twój opis",
"fr.approvedHint": "Opłać koszty odzyskania, aby otrzymać jego dane kontaktowe.",
"fr.photoAlt": "Zdjęcie przesłane przez znalazcę",
"fd.textFound": "Każde fałszywe oświadczenie stanowi oszustwo podlegające postępowaniu sądowemu zgodnie z obowiązującym prawem w Twoim kraju.",
"rp.otherPh": "Określ powód zgłoszenia…",
"rp.otherRequired": "Określ powód zgłoszenia.",
"mc.cancelClaim": "Anuluj moje roszczenie",
"mc.cancelClaimDone": "Twoje roszczenie zostało anulowane.",
"mc.cancelClaimConfirm": "Czy na pewno chcesz anulować swoje zgłoszenie?",
"mc.confirm": "Potwierdź",
"mc.cancel": "Anuluj",
"mc.stDeposited": "Zdeponowano",
"mc.stClaimed": "Zgłoszono",
"mc.stReturned": "Zwrócono",
"mc.progress": "Postęp"
},
"ru": {
"vq.title": "Вопросы для подтверждения личности",
"vq.optional": "(необязательно — рекомендуется)",
"vq.hint": "Задайте от 1 до 3 вопросов, ответ на которые знает только настоящий владелец (например, цвет детали, содержимое, особая примета). Никогда не отображаются публично.",
"vq.hintDeposit": "Задайте от 1 до 3 вопросов, ответ на которые знает только настоящий владелец (например, цвет детали, содержимое, особая примета). Они будут использоваться для проверки заявления. Никогда не отображаются публично.",
"vq.question": "Вопрос {n}",
"vq.optionalSuffix": "(необязательный)",
"vq.noneWarning": "Вопросы не добавлены. Мы рекомендуем указать хотя бы один, чтобы обезопасить возврат и избежать ложных заявлений.",
"vq.registryRef": "Справка для подтверждения владельца при возврате — никогда не отображается публично.",
"vq.answersIntroQ": "Чтобы избежать ложных заявлений, ответьте на вопросы ниже (цвет детали, марка, содержимое, особая примета). Ваши ответы не видны ни публично, ни в объявлении.",
"vq.answersIntroFree": "Чтобы избежать ложных заявлений, опишите 2–3 точные характеристики предмета (цвет детали, марка, содержимое, особая примета). Ваши ответы не видны ни публично, ни в объявлении.",
"vq.characteristic": "Характеристика {n}",
"vq.answerPh": "Ваш ответ…",
"vq.charPh": "Напр. царапина в правом нижнем углу",
"vq.sending": "Отправка…",
"vq.submit": "Отправить мою проверку",
"vq.cancel": "Отмена",
"vq.rejectTitle": "Отклонить заявление",
"vq.rejectHint": "Кратко укажите причину. Эта причина будет передана заявителю.",
"vq.rejectNoMatch": "Ответы не совпадают",
"vq.rejectVague": "Описание слишком расплывчатое",
"vq.rejectReturned": "Предмет уже возвращён",
"vq.rejectOther": "Другое",
"vq.rejectOtherPh": "Уточните причину…",
"vq.rejectConfirm": "Подтвердить отклонение",
"fd.title": "Внимание",
"fd.text": "Любое ложное заявление может привести к приостановке или даже окончательному удалению вашей учётной записи Findloop.",
"fd.continue": "Я понимаю, продолжить",
"fd.cancel": "Отмена",
"fr.already": "Вы уже сообщили, что нашли этот предмет. Ваше заявление находится в обработке.",
"fr.photoLabel": "Фото найденного предмета",
"fr.photoHint": "Оно будет показано владельцу, чтобы он подтвердил, что это действительно его предмет.",
"fr.photoError": "Добавьте фото найденного предмета.",
"fr.isItYours": "Это ваш предмет?",
"fr.isItYoursHint": "Нашедший отправил фото ниже. Если это ваш предмет, опишите несколько особых примет, чтобы это доказать.",
"fr.yesMine": "Да, это мой предмет",
"fr.notMine": "Это не мой предмет",
"fr.stPending": "Нашедший проверяет ваше описание",
"fr.stRejected": "Характеристики не подтверждены",
"fr.stApproved": "Подтверждено нашедшим",
"fr.proveTitle": "Докажите, что это ваш предмет",
"fr.proveHint": "Опишите характеристики, которые знает только владелец: цвет, марка, гравировка, содержимое, видимый дефект… Нашедший подтвердит, совпадают ли они.",
"fr.sent": "Описание отправлено нашедшему. Вы получите уведомление о его ответе.",
"fr.approvedTitle": "Нашедший подтвердил ваше описание",
"fr.approvedHint": "Оплатите сбор за получение, чтобы получить его контактные данные.",
"fr.photoAlt": "Фото, отправленное нашедшим",
"fd.textFound": "Любое ложное заявление является мошенничеством и может повлечь судебное преследование в соответствии с действующим законодательством вашей страны.",
"rp.otherPh": "Уточните причину жалобы…",
"rp.otherRequired": "Уточните причину жалобы.",
"mc.cancelClaim": "Отменить мою претензию",
"mc.cancelClaimDone": "Ваша претензия была отменена.",
"mc.cancelClaimConfirm": "Вы уверены, что хотите отменить свою заявку?",
"mc.confirm": "Подтвердить",
"mc.cancel": "Отмена",
"mc.stDeposited": "Сдано",
"mc.stClaimed": "Заявлено",
"mc.stReturned": "Возвращено",
"mc.progress": "Прогресс"
},
"uk": {
"vq.title": "Питання для перевірки особи",
"vq.optional": "(необов’язково — рекомендовано)",
"vq.hint": "Поставте від 1 до 3 запитань, відповідь на які знає лише справжній власник (напр., колір деталі, вміст, особлива ознака). Ніколи не відображаються публічно.",
"vq.hintDeposit": "Поставте від 1 до 3 запитань, відповідь на які знає лише справжній власник (напр., колір деталі, вміст, особлива ознака). Вони слугуватимуть для підтвердження звернення. Ніколи не відображаються публічно.",
"vq.question": "Питання {n}",
"vq.optionalSuffix": "(необов’язкове)",
"vq.noneWarning": "Не додано жодного запитання. Радимо вказати принаймні одне, щоб убезпечити повернення та уникнути неправдивих звернень.",
"vq.registryRef": "Посилання для підтвердження власника під час повернення — ніколи не відображається публічно.",
"vq.answersIntroQ": "Щоб уникнути неправдивих звернень, дайте відповіді на запитання нижче (колір деталі, бренд, вміст, особлива ознака). Ваші відповіді не видно ані публічно, ані в оголошенні.",
"vq.answersIntroFree": "Щоб уникнути неправдивих звернень, опишіть 2–3 точні характеристики предмета (колір деталі, бренд, вміст, особлива ознака). Ваші відповіді не видно ані публічно, ані в оголошенні.",
"vq.characteristic": "Характеристика {n}",
"vq.answerPh": "Ваша відповідь…",
"vq.charPh": "Напр. подряпина в нижньому правому куті",
"vq.sending": "Надсилання…",
"vq.submit": "Надіслати мою перевірку",
"vq.cancel": "Скасувати",
"vq.rejectTitle": "Відхилити звернення",
"vq.rejectHint": "Коротко вкажіть причину. Цю причину буде передано заявнику.",
"vq.rejectNoMatch": "Відповіді не збігаються",
"vq.rejectVague": "Опис надто нечіткий",
"vq.rejectReturned": "Предмет уже повернено",
"vq.rejectOther": "Інше",
"vq.rejectOtherPh": "Уточніть причину…",
"vq.rejectConfirm": "Підтвердити відхилення",
"fd.title": "Увага",
"fd.text": "Будь-яка неправдива заява може призвести до призупинення або навіть остаточного видалення вашого облікового запису Findloop.",
"fd.continue": "Розумію, продовжити",
"fd.cancel": "Скасувати",
"fr.already": "Ви вже повідомили, що знайшли цей предмет. Ваше повідомлення обробляється.",
"fr.photoLabel": "Фото знайденого предмета",
"fr.photoHint": "Його буде показано власнику, щоб він підтвердив, що це справді його предмет.",
"fr.photoError": "Додайте фото знайденого предмета.",
"fr.isItYours": "Це справді ваш предмет?",
"fr.isItYoursHint": "Той, хто знайшов, надіслав фото нижче. Якщо це ваш предмет, опишіть кілька особливих ознак, щоб це довести.",
"fr.yesMine": "Так, це мій предмет",
"fr.notMine": "Це не мій предмет",
"fr.stPending": "Той, хто знайшов, перевіряє ваш опис",
"fr.stRejected": "Характеристики не підтверджено",
"fr.stApproved": "Підтверджено тим, хто знайшов",
"fr.proveTitle": "Доведіть, що це ваш предмет",
"fr.proveHint": "Опишіть характеристики, які знає лише власник: колір, бренд, гравіювання, вміст, видимий дефект… Той, хто знайшов, підтвердить, чи збігаються вони.",
"fr.sent": "Опис надіслано тому, хто знайшов. Ви отримаєте сповіщення про його відповідь.",
"fr.approvedTitle": "Той, хто знайшов, підтвердив ваш опис",
"fr.approvedHint": "Сплатіть збір за отримання, щоб отримати його контактні дані.",
"fr.photoAlt": "Фото, надіслане тим, хто знайшов",
"fd.textFound": "Будь-яка неправдива заява є шахрайством і може призвести до судового переслідування згідно з чинним законодавством вашої країни.",
"rp.otherPh": "Уточніть причину скарги…",
"rp.otherRequired": "Уточніть причину скарги.",
"mc.cancelClaim": "Скасувати мою заяву",
"mc.cancelClaimDone": "Вашу заяву скасовано.",
"mc.cancelClaimConfirm": "Ви впевнені, що хочете скасувати свою заявку?",
"mc.confirm": "Підтвердити",
"mc.cancel": "Скасувати",
"mc.stDeposited": "Здано",
"mc.stClaimed": "Заявлено",
"mc.stReturned": "Повернуто",
"mc.progress": "Прогрес"
},
"tr": {
"vq.title": "Kimlik doğrulama soruları",
"vq.optional": "(isteğe bağlı — önerilir)",
"vq.hint": "Yalnızca gerçek sahibin cevabını bildiği 1 ila 3 soru sorun (örn. bir detayın rengi, içerik, ayırt edici işaret). Asla herkese açık olarak görünmez.",
"vq.hintDeposit": "Yalnızca gerçek sahibin cevabını bildiği 1 ila 3 soru sorun (örn. bir detayın rengi, içerik, ayırt edici işaret). Bunlar bir talebi doğrulamak için kullanılacaktır. Asla herkese açık olarak görünmez.",
"vq.question": "Soru {n}",
"vq.optionalSuffix": "(isteğe bağlı)",
"vq.noneWarning": "Hiç soru eklenmedi. Teslimi güvenceye almak ve sahte talepleri önlemek için en az bir tane eklemenizi öneririz.",
"vq.registryRef": "Teslim sırasında sahibini doğrulamak için referans — asla herkese açık olarak görünmez.",
"vq.answersIntroQ": "Sahte talepleri önlemek için aşağıdaki soruları yanıtlayın (bir detayın rengi, marka, içerik, ayırt edici işaret). Yanıtlarınız ne herkese açık olarak ne de ilanda görünür.",
"vq.answersIntroFree": "Sahte talepleri önlemek için eşyanın 2 ila 3 kesin özelliğini açıklayın (bir detayın rengi, marka, içerik, ayırt edici işaret). Yanıtlarınız ne herkese açık olarak ne de ilanda görünür.",
"vq.characteristic": "Özellik {n}",
"vq.answerPh": "Yanıtınız…",
"vq.charPh": "Örn. sağ alt köşede çizik",
"vq.sending": "Gönderiliyor…",
"vq.submit": "Doğrulamamı gönder",
"vq.cancel": "İptal",
"vq.rejectTitle": "Talebi reddet",
"vq.rejectHint": "Kısaca nedenini belirtin. Bu gerekçe talepte bulunan kişiye iletilecektir.",
"vq.rejectNoMatch": "Yanıtlar eşleşmiyor",
"vq.rejectVague": "Açıklama çok belirsiz",
"vq.rejectReturned": "Eşya zaten teslim edildi",
"vq.rejectOther": "Diğer",
"vq.rejectOtherPh": "Gerekçeyi belirtin…",
"vq.rejectConfirm": "Reddetmeyi onayla",
"fd.title": "Dikkat",
"fd.text": "Her türlü yanlış beyan, Findloop hesabınızın askıya alınmasına, hatta kalıcı olarak silinmesine yol açabilir.",
"fd.continue": "Anladım, devam et",
"fd.cancel": "İptal",
"fr.already": "Bu eşyayı bulduğunuzu daha önce bildirdiniz. Bildiriminiz işleniyor.",
"fr.photoLabel": "Bulunan eşyanın fotoğrafı",
"fr.photoHint": "Bunun gerçekten kendi eşyası olduğunu doğrulaması için sahibine gösterilecektir.",
"fr.photoError": "Bulunan eşyanın bir fotoğrafını ekleyin.",
"fr.isItYours": "Bu gerçekten sizin eşyanız mı?",
"fr.isItYoursHint": "Bir bulan kişi aşağıdaki fotoğrafı gönderdi. Eğer bu sizin eşyanızsa, bunu kanıtlamak için birkaç ayırt edici özelliği açıklayın.",
"fr.yesMine": "Evet, bu benim eşyam",
"fr.notMine": "Bu benim eşyam değil",
"fr.stPending": "Bulan kişi açıklamanızı doğruluyor",
"fr.stRejected": "Özellikler doğrulanmadı",
"fr.stApproved": "Bulan kişi tarafından onaylandı",
"fr.proveTitle": "Bunun sizin eşyanız olduğunu kanıtlayın",
"fr.proveHint": "Yalnızca sahibinin bildiği özellikleri açıklayın: renk, marka, kazıma, içerik, görünür kusur… Bulan kişi eşleşip eşleşmediklerini onaylayacaktır.",
"fr.sent": "Açıklama bulan kişiye gönderildi. Yanıtı hakkında size bildirim yapılacak.",
"fr.approvedTitle": "Bulan kişi açıklamanızı onayladı",
"fr.approvedHint": "İletişim bilgilerini almak için teslim alma ücretlerini ödeyin.",
"fr.photoAlt": "Bulan kişi tarafından gönderilen fotoğraf",
"fd.textFound": "Yürürlükteki ülke mevzuatına göre, herhangi bir yanlış beyan dolandırıcılık teşkil eder ve yasal takibata konu olabilir.",
"rp.otherPh": "Bildirimin nedenini belirtin…",
"rp.otherRequired": "Bildirimin nedenini belirtin.",
"mc.cancelClaim": "Talebimi iptal et",
"mc.cancelClaimDone": "Talebiniz iptal edildi.",
"mc.cancelClaimConfirm": "Talebinizi iptal etmek istediğinizden emin misiniz?",
"mc.confirm": "Onayla",
"mc.cancel": "İptal",
"mc.stDeposited": "Teslim edildi",
"mc.stClaimed": "Talep edildi",
"mc.stReturned": "İade edildi",
"mc.progress": "İlerleme"
},
"ar": {
"vq.title": "أسئلة التحقق من الهوية",
"vq.optional": "(اختياري — موصى به)",
"vq.hint": "اطرح من 1 إلى 3 أسئلة لا يعرف إجابتها إلا المالك الحقيقي (مثل لون تفصيل، المحتوى، علامة مميزة). لا تظهر علنًا أبدًا.",
"vq.hintDeposit": "اطرح من 1 إلى 3 أسئلة لا يعرف إجابتها إلا المالك الحقيقي (مثل لون تفصيل، المحتوى، علامة مميزة). ستُستخدم للتحقق من صحة المطالبة. لا تظهر علنًا أبدًا.",
"vq.question": "السؤال {n}",
"vq.optionalSuffix": "(اختياري)",
"vq.noneWarning": "لم تتم إضافة أي سؤال. ننصحك بإضافة سؤال واحد على الأقل لتأمين عملية التسليم وتجنب المطالبات الكاذبة.",
"vq.registryRef": "مرجع للتحقق من المالك عند التسليم — لا يظهر علنًا أبدًا.",
"vq.answersIntroQ": "لتجنب المطالبات الكاذبة، أجب عن الأسئلة أدناه (لون تفصيل، العلامة التجارية، المحتوى، علامة مميزة). إجاباتك غير مرئية لا علنًا ولا في الإعلان.",
"vq.answersIntroFree": "لتجنب المطالبات الكاذبة، صف 2 إلى 3 خصائص دقيقة للغرض (لون تفصيل، العلامة التجارية، المحتوى، علامة مميزة). إجاباتك غير مرئية لا علنًا ولا في الإعلان.",
"vq.characteristic": "خاصية {n}",
"vq.answerPh": "إجابتك…",
"vq.charPh": "مثال: خدش في الزاوية السفلية اليمنى",
"vq.sending": "جارٍ الإرسال…",
"vq.submit": "إرسال التحقق الخاص بي",
"vq.cancel": "إلغاء",
"vq.rejectTitle": "رفض المطالبة",
"vq.rejectHint": "اذكر السبب باختصار. سيتم إرسال هذا السبب إلى مقدّم المطالبة.",
"vq.rejectNoMatch": "الإجابات غير متطابقة",
"vq.rejectVague": "الوصف غامض جدًا",
"vq.rejectReturned": "تمت إعادة الغرض بالفعل",
"vq.rejectOther": "أخرى",
"vq.rejectOtherPh": "حدّد السبب…",
"vq.rejectConfirm": "تأكيد الرفض",
"fd.title": "تنبيه",
"fd.text": "أي تصريح كاذب قد يؤدي إلى تعليق حسابك على Findloop، أو حتى حذفه نهائيًا.",
"fd.continue": "أفهم، متابعة",
"fd.cancel": "إلغاء",
"fr.already": "لقد أبلغت بالفعل أنك وجدت هذا الغرض. بلاغك قيد المعالجة.",
"fr.photoLabel": "صورة الغرض المعثور عليه",
"fr.photoHint": "سيتم عرضها على المالك لكي يؤكد أنه غرضه بالفعل.",
"fr.photoError": "أضف صورة للغرض المعثور عليه.",
"fr.isItYours": "هل هذا غرضك فعلًا؟",
"fr.isItYoursHint": "أرسل أحد العاثرين الصورة أدناه. إذا كان هذا غرضك، فصف بعض العلامات المميزة لإثبات ذلك.",
"fr.yesMine": "نعم، هذا غرضي",
"fr.notMine": "هذا ليس غرضي",
"fr.stPending": "العاثر يتحقق من وصفك",
"fr.stRejected": "لم يتم تأكيد الخصائص",
"fr.stApproved": "تم التأكيد من قِبل العاثر",
"fr.proveTitle": "أثبت أن هذا غرضك",
"fr.proveHint": "صف خصائص لا يعرفها إلا المالك: اللون، العلامة التجارية، النقش، المحتوى، عيب ظاهر… سيؤكد العاثر ما إذا كانت مطابقة.",
"fr.sent": "تم إرسال الوصف إلى العاثر. سيتم إشعارك بردّه.",
"fr.approvedTitle": "أكد العاثر وصفك",
"fr.approvedHint": "ادفع رسوم الاسترداد للحصول على بيانات التواصل الخاصة به.",
"fr.photoAlt": "صورة أرسلها العاثر",
"fd.textFound": "أي تصريح كاذب يُعد احتيالًا ويعرّض صاحبه للملاحقة القضائية وفقًا للتشريعات السارية في بلدك.",
"rp.otherPh": "يرجى توضيح سبب الإبلاغ…",
"rp.otherRequired": "يرجى توضيح سبب الإبلاغ.",
"mc.cancelClaim": "إلغاء مطالبتي",
"mc.cancelClaimDone": "تم إلغاء مطالبتك.",
"mc.cancelClaimConfirm": "هل أنت متأكد أنك تريد إلغاء مطالبتك؟",
"mc.confirm": "تأكيد",
"mc.cancel": "إلغاء",
"mc.stDeposited": "مُودَع",
"mc.stClaimed": "تمت المطالبة به",
"mc.stReturned": "أُعيد",
"mc.progress": "التقدم"
},
"he": {
"vq.title": "שאלות לאימות זהות",
"vq.optional": "(אופציונלי — מומלץ)",
"vq.hint": "שאלו 1 עד 3 שאלות שרק הבעלים האמיתי יודע את התשובה עליהן (למשל צבע של פרט, תוכן, סימן מזהה). לעולם לא יוצגו בפומבי.",
"vq.hintDeposit": "שאלו 1 עד 3 שאלות שרק הבעלים האמיתי יודע את התשובה עליהן (למשל צבע של פרט, תוכן, סימן מזהה). הן ישמשו לאימות תביעה. לעולם לא יוצגו בפומבי.",
"vq.question": "שאלה {n}",
"vq.optionalSuffix": "(אופציונלית)",
"vq.noneWarning": "לא נוספה אף שאלה. אנו ממליצים למלא לפחות שאלה אחת כדי לאבטח את ההשבה ולמנוע תביעות כוזבות.",
"vq.registryRef": "אסמכתה לאימות הבעלים בעת ההשבה — לעולם לא גלויה בפומבי.",
"vq.answersIntroQ": "כדי למנוע תביעות כוזבות, השיבו על השאלות שלהלן (צבע של פרט, מותג, תוכן, סימן מזהה). התשובות שלכם אינן גלויות לא לציבור ולא במודעה.",
"vq.answersIntroFree": "כדי למנוע תביעות כוזבות, תארו 2 עד 3 מאפיינים מדויקים של הפריט (צבע של פרט, מותג, תוכן, סימן מזהה). התשובות שלכם אינן גלויות לא לציבור ולא במודעה.",
"vq.characteristic": "מאפיין {n}",
"vq.answerPh": "התשובה שלכם…",
"vq.charPh": "למשל שריטה בפינה הימנית התחתונה",
"vq.sending": "שולח…",
"vq.submit": "שלח את האימות שלי",
"vq.cancel": "ביטול",
"vq.rejectTitle": "דחיית התביעה",
"vq.rejectHint": "ציינו בקצרה למה. נימוק זה יישלח לתובע.",
"vq.rejectNoMatch": "התשובות אינן תואמות",
"vq.rejectVague": "התיאור מעורפל מדי",
"vq.rejectReturned": "הפריט כבר הוחזר",
"vq.rejectOther": "אחר",
"vq.rejectOtherPh": "פרטו את הסיבה…",
"vq.rejectConfirm": "אישור הדחייה",
"fd.title": "שים לב",
"fd.text": "כל הצהרה כוזבת עלולה להוביל להשעיה ואף למחיקה סופית של חשבון Findloop שלך.",
"fd.continue": "הבנתי, המשך",
"fd.cancel": "ביטול",
"fr.already": "כבר דיווחת שמצאת את הפריט הזה. הדיווח שלך נמצא בטיפול.",
"fr.photoLabel": "תמונה של הפריט שנמצא",
"fr.photoHint": "היא תוצג לבעלים כדי שיוכל לאשר שזה אכן הפריט שלו.",
"fr.photoError": "הוסף תמונה של הפריט שנמצא.",
"fr.isItYours": "האם זה אכן הפריט שלך?",
"fr.isItYoursHint": "מוצא שלח את התמונה שלהלן. אם זה הפריט שלך, תאר כמה סימנים מזהים כדי להוכיח זאת.",
"fr.yesMine": "כן, זה הפריט שלי",
"fr.notMine": "זה לא הפריט שלי",
"fr.stPending": "המוצא בודק את התיאור שלך",
"fr.stRejected": "המאפיינים לא אושרו",
"fr.stApproved": "אושר על ידי המוצא",
"fr.proveTitle": "הוכח שזה הפריט שלך",
"fr.proveHint": "תאר מאפיינים שרק הבעלים מכיר: צבע, מותג, חריטה, תוכן, פגם נראה לעין… המוצא יאשר אם הם תואמים.",
"fr.sent": "התיאור נשלח למוצא. תקבל/י התראה על תגובתו.",
"fr.approvedTitle": "המוצא אישר את התיאור שלך",
"fr.approvedHint": "שלם/י את דמי האיסוף כדי לקבל את פרטי הקשר שלו.",
"fr.photoAlt": "תמונה שנשלחה על ידי המוצא",
"fd.textFound": "כל הצהרה כוזבת מהווה הונאה שעשויה להוביל להליכים משפטיים בהתאם לחקיקה התקפה במדינתך.",
"rp.otherPh": "נא לציין את סיבת הדיווח…",
"rp.otherRequired": "נא לציין את סיבת הדיווח.",
"mc.cancelClaim": "לבטל את התביעה שלי",
"mc.cancelClaimDone": "התביעה שלך בוטלה.",
"mc.cancelClaimConfirm": "האם אתה בטוח שברצונך לבטל את התביעה שלך?",
"mc.confirm": "אישור",
"mc.cancel": "ביטול",
"mc.stDeposited": "הופקד",
"mc.stClaimed": "נתבע",
"mc.stReturned": "הוחזר",
"mc.progress": "התקדמות"
},
"zh": {
"vq.title": "身份验证问题",
"vq.optional": "（可选——建议）",
"vq.hint": "请提出 1 到 3 个只有真正失主知道答案的问题（例如某个细节的颜色、内容、特殊标记）。这些内容绝不会公开显示。",
"vq.hintDeposit": "请提出 1 到 3 个只有真正失主知道答案的问题（例如某个细节的颜色、内容、特殊标记）。它们将用于验证认领。绝不会公开显示。",
"vq.question": "问题 {n}",
"vq.optionalSuffix": "（可选）",
"vq.noneWarning": "尚未添加任何问题。我们建议您至少填写一个问题，以确保归还安全并避免虚假认领。",
"vq.registryRef": "用于在归还时验证失主身份的参考信息——绝不会公开显示。",
"vq.answersIntroQ": "为避免虚假认领，请回答以下问题（某个细节的颜色、品牌、内容、特殊标记）。您的回答不会公开显示，也不会显示在公告中。",
"vq.answersIntroFree": "为避免虚假认领，请描述该物品的 2 到 3 个精确特征（某个细节的颜色、品牌、内容、特殊标记）。您的回答不会公开显示，也不会显示在公告中。",
"vq.characteristic": "特征 {n}",
"vq.answerPh": "您的回答…",
"vq.charPh": "例如：右下角有一道划痕",
"vq.sending": "发送中…",
"vq.submit": "发送我的验证",
"vq.cancel": "取消",
"vq.rejectTitle": "拒绝认领",
"vq.rejectHint": "请简要说明原因。该理由将发送给认领人。",
"vq.rejectNoMatch": "回答不匹配",
"vq.rejectVague": "描述过于模糊",
"vq.rejectReturned": "物品已归还",
"vq.rejectOther": "其他",
"vq.rejectOtherPh": "请说明原因…",
"vq.rejectConfirm": "确认拒绝",
"fd.title": "注意",
"fd.text": "任何虚假声明都可能导致您的 Findloop 账户被暂停，甚至被永久删除。",
"fd.continue": "我已了解，继续",
"fd.cancel": "取消",
"fr.already": "您已经报告过找到此物品。您的申报正在处理中。",
"fr.photoLabel": "找到物品的照片",
"fr.photoHint": "该照片将展示给失主，以便其确认这确实是自己的物品。",
"fr.photoError": "请添加一张找到物品的照片。",
"fr.isItYours": "这是您的物品吗？",
"fr.isItYoursHint": "拾得者已发送下方照片。如果这是您的物品，请描述一些特殊特征以证明。",
"fr.yesMine": "是的，这是我的物品",
"fr.notMine": "这不是我的物品",
"fr.stPending": "拾得者正在核实您的描述",
"fr.stRejected": "特征未获确认",
"fr.stApproved": "已由拾得者确认",
"fr.proveTitle": "证明这是您的物品",
"fr.proveHint": "请描述只有失主才知道的特征：颜色、品牌、刻字、内容、可见瑕疵……拾得者会确认是否匹配。",
"fr.sent": "描述已发送给拾得者。您会收到其回复通知。",
"fr.approvedTitle": "拾得者已确认您的描述",
"fr.approvedHint": "请支付取回费用以获取其联系方式。",
"fr.photoAlt": "拾得者发送的照片",
"fd.textFound": "任何虚假声明均构成欺诈行为，并将根据您所在国家/地区现行法律受到法律追究。",
"rp.otherPh": "请说明举报原因…",
"rp.otherRequired": "请说明举报原因。",
"mc.cancelClaim": "取消我的认领申请",
"mc.cancelClaimDone": "您的认领申请已取消。",
"mc.cancelClaimConfirm": "您确定要取消您的认领吗？",
"mc.confirm": "确认",
"mc.cancel": "取消",
"mc.stDeposited": "已存放",
"mc.stClaimed": "已认领",
"mc.stReturned": "已归还",
"mc.progress": "进度"
},
"ja": {
"vq.title": "本人確認用の質問",
"vq.optional": "（任意 — 推奨）",
"vq.hint": "本当の持ち主だけが答えを知っている質問を1〜3個設定してください（例：一部の色、中身、特徴的な印）。公開されることはありません。",
"vq.hintDeposit": "本当の持ち主だけが答えを知っている質問を1〜3個設定してください（例：一部の色、中身、特徴的な印）。これらは申請の確認に使用されます。公開されることはありません。",
"vq.question": "質問 {n}",
"vq.optionalSuffix": "（任意）",
"vq.noneWarning": "質問が追加されていません。返却を安全に行い、虚偽の申請を避けるため、少なくとも1つ入力することをおすすめします。",
"vq.registryRef": "返却時に持ち主を確認するための参照情報 — 公開されることはありません。",
"vq.answersIntroQ": "虚偽の申請を避けるため、以下の質問に回答してください（一部の色、ブランド、中身、特徴的な印）。あなたの回答は公開されず、掲載にも表示されません。",
"vq.answersIntroFree": "虚偽の申請を避けるため、物の正確な特徴を2〜3つ説明してください（一部の色、ブランド、中身、特徴的な印）。あなたの回答は公開されず、掲載にも表示されません。",
"vq.characteristic": "特徴 {n}",
"vq.answerPh": "あなたの回答…",
"vq.charPh": "例：右下の角に傷",
"vq.sending": "送信中…",
"vq.submit": "確認を送信",
"vq.cancel": "キャンセル",
"vq.rejectTitle": "申請を却下",
"vq.rejectHint": "理由を簡潔に入力してください。この理由は申請者に送信されます。",
"vq.rejectNoMatch": "回答が一致しません",
"vq.rejectVague": "説明があいまいすぎます",
"vq.rejectReturned": "品物はすでに返却済みです",
"vq.rejectOther": "その他",
"vq.rejectOtherPh": "理由を入力してください…",
"vq.rejectConfirm": "却下を確定",
"fd.title": "注意",
"fd.text": "虚偽の申告を行った場合、Findloopアカウントの停止、または永久削除の対象となることがあります。",
"fd.continue": "理解しました。続行",
"fd.cancel": "キャンセル",
"fr.already": "この品物を見つけたと、すでに報告済みです。現在、申告を処理中です。",
"fr.photoLabel": "見つかった品物の写真",
"fr.photoHint": "持ち主に表示され、その品物が本人のものか確認してもらいます。",
"fr.photoError": "見つかった品物の写真を追加してください。",
"fr.isItYours": "これはあなたの品物ですか？",
"fr.isItYoursHint": "拾得者が以下の写真を送信しました。あなたの品物であれば、それを証明するためにいくつかの特徴を説明してください。",
"fr.yesMine": "はい、私の品物です",
"fr.notMine": "これは私の品物ではありません",
"fr.stPending": "拾得者があなたの説明を確認しています",
"fr.stRejected": "特徴が確認されませんでした",
"fr.stApproved": "拾得者によって確認済み",
"fr.proveTitle": "あなたの品物であることを証明してください",
"fr.proveHint": "持ち主だけが知っている特徴を説明してください：色、ブランド、刻印、中身、目に見える欠陥など… 拾得者が一致するか確認します。",
"fr.sent": "説明が拾得者に送信されました。回答があり次第通知されます。",
"fr.approvedTitle": "拾得者があなたの説明を確認しました",
"fr.approvedHint": "連絡先を受け取るには、受け取り手数料をお支払いください。",
"fr.photoAlt": "拾得者が送信した写真",
"fd.textFound": "虚偽の申告は、あなたの国で適用される現行法に基づき、法的措置の対象となる不正行為です。",
"rp.otherPh": "報告の理由を入力してください…",
"rp.otherRequired": "報告の理由を入力してください。",
"mc.cancelClaim": "請求をキャンセルする",
"mc.cancelClaimDone": "あなたの請求はキャンセルされました。",
"mc.cancelClaimConfirm": "この申請を取り消してもよろしいですか？",
"mc.confirm": "確認",
"mc.cancel": "キャンセル",
"mc.stDeposited": "預け済み",
"mc.stClaimed": "申請済み",
"mc.stReturned": "返却済み",
"mc.progress": "進捗"
},
"ko": {
"vq.title": "신원 확인 질문",
"vq.optional": "(선택 사항 — 권장)",
"vq.hint": "실제 소유자만 답을 아는 질문을 1~3개 작성하세요(예: 세부 요소의 색상, 내용물, 특징적인 표시). 공개적으로는 절대 표시되지 않습니다.",
"vq.hintDeposit": "실제 소유자만 답을 아는 질문을 1~3개 작성하세요(예: 세부 요소의 색상, 내용물, 특징적인 표시). 이 질문들은 분실물 요청을 확인하는 데 사용됩니다. 공개적으로는 절대 표시되지 않습니다.",
"vq.question": "질문 {n}",
"vq.optionalSuffix": "(선택 사항)",
"vq.noneWarning": "추가된 질문이 없습니다. 반환을 안전하게 진행하고 허위 요청을 방지하기 위해 최소 1개 이상 입력하는 것을 권장합니다.",
"vq.registryRef": "반환 시 소유자를 확인하기 위한 참조 정보 — 공개적으로는 절대 표시되지 않습니다.",
"vq.answersIntroQ": "허위 요청을 방지하기 위해 아래 질문에 답해주세요(세부 요소의 색상, 브랜드, 내용물, 특징적인 표시). 답변은 공개적으로도, 게시물에도 표시되지 않습니다.",
"vq.answersIntroFree": "허위 요청을 방지하기 위해 물건의 구체적인 특징 2~3가지를 설명해주세요(세부 요소의 색상, 브랜드, 내용물, 특징적인 표시). 답변은 공개적으로도, 게시물에도 표시되지 않습니다.",
"vq.characteristic": "특징 {n}",
"vq.answerPh": "답변을 입력하세요…",
"vq.charPh": "예: 오른쪽 아래 모서리의 긁힘",
"vq.sending": "전송 중…",
"vq.submit": "내 확인 정보 보내기",
"vq.cancel": "취소",
"vq.rejectTitle": "요청 거절",
"vq.rejectHint": "이유를 간단히 입력하세요. 이 사유는 요청자에게 전달됩니다.",
"vq.rejectNoMatch": "답변이 일치하지 않습니다",
"vq.rejectVague": "설명이 너무 모호합니다",
"vq.rejectReturned": "물건이 이미 반환되었습니다",
"vq.rejectOther": "기타",
"vq.rejectOtherPh": "사유를 입력하세요…",
"vq.rejectConfirm": "거절 확인",
"fd.title": "주의",
"fd.text": "허위 신고를 할 경우 Findloop 계정이 일시 정지되거나 영구적으로 삭제될 수 있습니다.",
"fd.continue": "이해했습니다, 계속하기",
"fd.cancel": "취소",
"fr.already": "이 물건을 찾았다고 이미 신고하셨습니다. 현재 신고가 처리 중입니다.",
"fr.photoLabel": "찾은 물건의 사진",
"fr.photoHint": "소유자가 자신의 물건이 맞는지 확인할 수 있도록 표시됩니다.",
"fr.photoError": "찾은 물건의 사진을 추가하세요.",
"fr.isItYours": "이 물건이 정말 당신의 것인가요?",
"fr.isItYoursHint": "습득자가 아래 사진을 보냈습니다. 당신의 물건이 맞다면, 이를 증명할 수 있는 몇 가지 특징을 설명해주세요.",
"fr.yesMine": "네, 제 물건입니다",
"fr.notMine": "제 물건이 아닙니다",
"fr.stPending": "습득자가 당신의 설명을 확인 중입니다",
"fr.stRejected": "특징이 확인되지 않았습니다",
"fr.stApproved": "습득자가 확인했습니다",
"fr.proveTitle": "당신의 물건임을 증명하세요",
"fr.proveHint": "소유자만 아는 특징을 설명해주세요: 색상, 브랜드, 각인, 내용물, 눈에 띄는 결함 등… 습득자가 일치 여부를 확인합니다.",
"fr.sent": "설명이 습득자에게 전송되었습니다. 답변이 오면 알림을 받게 됩니다.",
"fr.approvedTitle": "습득자가 당신의 설명을 확인했습니다",
"fr.approvedHint": "연락처를 받으려면 수령 비용을 결제하세요.",
"fr.photoAlt": "습득자가 보낸 사진",
"fd.textFound": "허위 신고는 귀하의 국가에서 시행 중인 법률에 따라 사법 절차의 대상이 되는 사기에 해당합니다.",
"rp.otherPh": "신고 사유를 구체적으로 입력해 주세요…",
"rp.otherRequired": "신고 사유를 구체적으로 입력해 주세요.",
"mc.cancelClaim": "내 신고 취소",
"mc.cancelClaimDone": "회원님의 신고가 취소되었습니다.",
"mc.cancelClaimConfirm": "정말로 분실물 찾기 요청을 취소하시겠습니까?",
"mc.confirm": "확인",
"mc.cancel": "취소",
"mc.stDeposited": "보관됨",
"mc.stClaimed": "요청됨",
"mc.stReturned": "반환됨",
"mc.progress": "진행 상황"
},
"hi": {
"vq.title": "पहचान सत्यापन प्रश्न",
"vq.optional": "(वैकल्पिक — अनुशंसित)",
"vq.hint": "1 से 3 प्रश्न पूछें जिनका उत्तर केवल वास्तविक मालिक को पता हो (जैसे किसी विवरण का रंग, सामग्री, विशेष पहचान)। ये कभी भी सार्वजनिक रूप से दिखाई नहीं देंगे।",
"vq.hintDeposit": "1 से 3 प्रश्न पूछें जिनका उत्तर केवल वास्तविक मालिक को पता हो (जैसे किसी विवरण का रंग, सामग्री, विशेष पहचान)। इनका उपयोग दावे को सत्यापित करने के लिए किया जाएगा। ये कभी भी सार्वजनिक रूप से दिखाई नहीं देंगे।",
"vq.question": "प्रश्न {n}",
"vq.optionalSuffix": "(वैकल्पिक)",
"vq.noneWarning": "कोई प्रश्न नहीं जोड़ा गया। हम सलाह देते हैं कि वापसी को सुरक्षित बनाने और झूठे दावों से बचने के लिए कम से कम एक प्रश्न अवश्य जोड़ें।",
"vq.registryRef": "वापसी के समय मालिक की पुष्टि करने के लिए संदर्भ — कभी भी सार्वजनिक रूप से दिखाई नहीं देगा।",
"vq.answersIntroQ": "झूठे दावों से बचने के लिए, नीचे दिए गए प्रश्नों के उत्तर दें (किसी विवरण का रंग, ब्रांड, सामग्री, विशेष पहचान)। आपके उत्तर न तो सार्वजनिक रूप से दिखेंगे, न ही विज्ञापन पर।",
"vq.answersIntroFree": "झूठे दावों से बचने के लिए, वस्तु की 2 से 3 सटीक विशेषताएँ बताएं (किसी विवरण का रंग, ब्रांड, सामग्री, विशेष पहचान)। आपके उत्तर न तो सार्वजनिक रूप से दिखेंगे, न ही विज्ञापन पर।",
"vq.characteristic": "विशेषता {n}",
"vq.answerPh": "आपका उत्तर…",
"vq.charPh": "उदा. नीचे दाहिने कोने पर खरोंच",
"vq.sending": "भेजा जा रहा है…",
"vq.submit": "मेरा सत्यापन भेजें",
"vq.cancel": "रद्द करें",
"vq.rejectTitle": "दावे को अस्वीकार करें",
"vq.rejectHint": "संक्षेप में कारण बताएं। यह कारण दावेदार को भेजा जाएगा।",
"vq.rejectNoMatch": "उत्तर मेल नहीं खाते",
"vq.rejectVague": "विवरण बहुत अस्पष्ट है",
"vq.rejectReturned": "वस्तु पहले ही लौटाई जा चुकी है",
"vq.rejectOther": "अन्य",
"vq.rejectOtherPh": "कारण स्पष्ट करें…",
"vq.rejectConfirm": "अस्वीकृति की पुष्टि करें",
"fd.title": "ध्यान दें",
"fd.text": "किसी भी झूठी घोषणा के कारण आपके Findloop खाते को निलंबित किया जा सकता है, या स्थायी रूप से हटाया भी जा सकता है।",
"fd.continue": "मैं समझता/समझती हूँ, जारी रखें",
"fd.cancel": "रद्द करें",
"fr.already": "आप पहले ही इस वस्तु को मिलने की सूचना दे चुके हैं। आपकी सूचना पर कार्यवाही जारी है।",
"fr.photoLabel": "मिली हुई वस्तु की फोटो",
"fr.photoHint": "इसे मालिक को दिखाया जाएगा ताकि वह पुष्टि कर सके कि यह वास्तव में उसकी वस्तु है।",
"fr.photoError": "मिली हुई वस्तु की एक फोटो जोड़ें।",
"fr.isItYours": "क्या यह आपकी वस्तु है?",
"fr.isItYoursHint": "किसी पाने वाले ने नीचे दी गई फोटो भेजी है। यदि यह आपकी वस्तु है, तो इसे साबित करने के लिए कुछ विशेष पहचान बताएं।",
"fr.yesMine": "हाँ, यह मेरी वस्तु है",
"fr.notMine": "यह मेरी वस्तु नहीं है",
"fr.stPending": "पाने वाला आपके विवरण की जाँच कर रहा है",
"fr.stRejected": "विशेषताओं की पुष्टि नहीं हुई",
"fr.stApproved": "पाने वाले द्वारा पुष्टि की गई",
"fr.proveTitle": "साबित करें कि यह आपकी वस्तु है",
"fr.proveHint": "ऐसी विशेषताएँ बताएं जो केवल मालिक को पता हों: रंग, ब्रांड, नक्काशी, सामग्री, दिखाई देने वाला दोष… पाने वाला पुष्टि करेगा कि वे मेल खाती हैं या नहीं।",
"fr.sent": "विवरण पाने वाले को भेज दिया गया है। आपको उसके उत्तर की सूचना दी जाएगी।",
"fr.approvedTitle": "पाने वाले ने आपके विवरण की पुष्टि कर दी है",
"fr.approvedHint": "उसकी संपर्क जानकारी प्राप्त करने के लिए पुनर्प्राप्ति शुल्क का भुगतान करें।",
"fr.photoAlt": "पाने वाले द्वारा भेजी गई फोटो",
"fd.textFound": "कोई भी झूठी घोषणा आपके देश में लागू कानून के अनुसार न्यायिक कार्रवाई योग्य धोखाधड़ी मानी जाती है।",
"rp.otherPh": "रिपोर्ट करने का कारण स्पष्ट करें…",
"rp.otherRequired": "रिपोर्ट करने का कारण स्पष्ट करें।",
"mc.cancelClaim": "मेरी दावा रद्द करें",
"mc.cancelClaimDone": "आपका दावा रद्द कर दिया गया है।",
"mc.cancelClaimConfirm": "क्या आप वाकई अपना दावा रद्द करना चाहते हैं?",
"mc.confirm": "पुष्टि करें",
"mc.cancel": "रद्द करें",
"mc.stDeposited": "जमा किया गया",
"mc.stClaimed": "दावा किया गया",
"mc.stReturned": "वापस किया गया",
"mc.progress": "प्रगति"
},
"id": {
"vq.title": "Pertanyaan verifikasi identitas",
"vq.optional": "(opsional — disarankan)",
"vq.hint": "Ajukan 1 hingga 3 pertanyaan yang hanya diketahui jawabannya oleh pemilik asli (mis. warna suatu detail, isi, tanda khusus). Tidak pernah terlihat secara publik.",
"vq.hintDeposit": "Ajukan 1 hingga 3 pertanyaan yang hanya diketahui jawabannya oleh pemilik asli (mis. warna suatu detail, isi, tanda khusus). Pertanyaan ini akan digunakan untuk memvalidasi klaim. Tidak pernah terlihat secara publik.",
"vq.question": "Pertanyaan {n}",
"vq.optionalSuffix": "(opsional)",
"vq.noneWarning": "Belum ada pertanyaan yang ditambahkan. Kami menyarankan Anda mengisi setidaknya satu pertanyaan untuk mengamankan pengembalian dan menghindari klaim palsu.",
"vq.registryRef": "Referensi untuk memvalidasi pemilik saat pengembalian — tidak pernah terlihat secara publik.",
"vq.answersIntroQ": "Untuk menghindari klaim palsu, jawablah pertanyaan di bawah ini (warna suatu detail, merek, isi, tanda khusus). Jawaban Anda tidak terlihat secara publik maupun pada iklan.",
"vq.answersIntroFree": "Untuk menghindari klaim palsu, jelaskan 2 hingga 3 ciri spesifik dari barang tersebut (warna suatu detail, merek, isi, tanda khusus). Jawaban Anda tidak terlihat secara publik maupun pada iklan.",
"vq.characteristic": "Karakteristik {n}",
"vq.answerPh": "Jawaban Anda…",
"vq.charPh": "Mis. goresan di sudut kanan bawah",
"vq.sending": "Mengirim…",
"vq.submit": "Kirim verifikasi saya",
"vq.cancel": "Batal",
"vq.rejectTitle": "Tolak klaim",
"vq.rejectHint": "Jelaskan secara singkat alasannya. Alasan ini akan diteruskan kepada pengklaim.",
"vq.rejectNoMatch": "Jawaban tidak cocok",
"vq.rejectVague": "Deskripsi terlalu samar",
"vq.rejectReturned": "Barang sudah dikembalikan",
"vq.rejectOther": "Lainnya",
"vq.rejectOtherPh": "Jelaskan alasannya…",
"vq.rejectConfirm": "Konfirmasi penolakan",
"fd.title": "Perhatian",
"fd.text": "Setiap pernyataan palsu dapat mengakibatkan penangguhan, bahkan penghapusan permanen akun Findloop Anda.",
"fd.continue": "Saya mengerti, lanjutkan",
"fd.cancel": "Batal",
"fr.already": "Anda sudah melaporkan bahwa Anda menemukan barang ini. Laporan Anda sedang diproses.",
"fr.photoLabel": "Foto barang yang ditemukan",
"fr.photoHint": "Foto ini akan ditunjukkan kepada pemilik agar ia dapat mengonfirmasi bahwa itu memang barang miliknya.",
"fr.photoError": "Tambahkan foto barang yang ditemukan.",
"fr.isItYours": "Apakah ini benar barang Anda?",
"fr.isItYoursHint": "Seorang penemu telah mengirim foto di bawah ini. Jika ini barang Anda, jelaskan beberapa tanda khusus untuk membuktikannya.",
"fr.yesMine": "Ya, ini barang saya",
"fr.notMine": "Ini bukan barang saya",
"fr.stPending": "Penemu sedang memeriksa deskripsi Anda",
"fr.stRejected": "Karakteristik tidak dikonfirmasi",
"fr.stApproved": "Dikonfirmasi oleh penemu",
"fr.proveTitle": "Buktikan bahwa ini barang Anda",
"fr.proveHint": "Jelaskan karakteristik yang hanya diketahui pemilik: warna, merek, ukiran, isi, cacat yang terlihat… Penemu akan mengonfirmasi apakah cocok.",
"fr.sent": "Deskripsi dikirim kepada penemu. Anda akan diberi tahu tentang jawabannya.",
"fr.approvedTitle": "Penemu telah mengonfirmasi deskripsi Anda",
"fr.approvedHint": "Bayar biaya pengambilan untuk mendapatkan detail kontaknya.",
"fr.photoAlt": "Foto yang dikirim oleh penemu",
"fd.textFound": "Setiap pernyataan palsu merupakan penipuan yang dapat dituntut secara hukum sesuai dengan peraturan perundang-undangan yang berlaku di negara Anda.",
"rp.otherPh": "Jelaskan alasan pelaporan…",
"rp.otherRequired": "Jelaskan alasan pelaporan.",
"mc.cancelClaim": "Batalkan klaim saya",
"mc.cancelClaimDone": "Klaim Anda telah dibatalkan.",
"mc.cancelClaimConfirm": "Apakah Anda yakin ingin membatalkan klaim Anda?",
"mc.confirm": "Konfirmasi",
"mc.cancel": "Batal",
"mc.stDeposited": "Diserahkan",
"mc.stClaimed": "Diklaim",
"mc.stReturned": "Dikembalikan",
"mc.progress": "Progres"
},
"th": {
"vq.title": "คำถามยืนยันตัวตน",
"vq.optional": "(ไม่บังคับ — แนะนำ)",
"vq.hint": "ตั้งคำถาม 1 ถึง 3 ข้อที่มีเพียงเจ้าของตัวจริงเท่านั้นที่รู้คำตอบ (เช่น สีของรายละเอียดบางจุด สิ่งของข้างใน จุดสังเกตพิเศษ) จะไม่แสดงต่อสาธารณะ",
"vq.hintDeposit": "ตั้งคำถาม 1 ถึง 3 ข้อที่มีเพียงเจ้าของตัวจริงเท่านั้นที่รู้คำตอบ (เช่น สีของรายละเอียดบางจุด สิ่งของข้างใน จุดสังเกตพิเศษ) คำถามเหล่านี้จะใช้เพื่อตรวจสอบการอ้างสิทธิ์ จะไม่แสดงต่อสาธารณะ",
"vq.question": "คำถาม {n}",
"vq.optionalSuffix": "(ไม่บังคับ)",
"vq.noneWarning": "ยังไม่ได้เพิ่มคำถามใดๆ เราแนะนำให้เพิ่มอย่างน้อยหนึ่งข้อเพื่อให้การคืนของปลอดภัยยิ่งขึ้นและหลีกเลี่ยงการอ้างสิทธิ์ปลอม",
"vq.registryRef": "ข้อมูลอ้างอิงสำหรับยืนยันเจ้าของเมื่อมีการคืนของ — จะไม่แสดงต่อสาธารณะ",
"vq.answersIntroQ": "เพื่อหลีกเลี่ยงการอ้างสิทธิ์ปลอม โปรดตอบคำถามด้านล่างนี้ (สีของรายละเอียดบางจุด ยี่ห้อ สิ่งของข้างใน จุดสังเกตพิเศษ) คำตอบของคุณจะไม่แสดงต่อสาธารณะหรือบนประกาศ",
"vq.answersIntroFree": "เพื่อหลีกเลี่ยงการอ้างสิทธิ์ปลอม โปรดอธิบายลักษณะเฉพาะของสิ่งของ 2 ถึง 3 ข้ออย่างเจาะจง (สีของรายละเอียดบางจุด ยี่ห้อ สิ่งของข้างใน จุดสังเกตพิเศษ) คำตอบของคุณจะไม่แสดงต่อสาธารณะหรือบนประกาศ",
"vq.characteristic": "ลักษณะเฉพาะ {n}",
"vq.answerPh": "คำตอบของคุณ…",
"vq.charPh": "เช่น รอยขีดที่มุมล่างขวา",
"vq.sending": "กำลังส่ง…",
"vq.submit": "ส่งการยืนยันของฉัน",
"vq.cancel": "ยกเลิก",
"vq.rejectTitle": "ปฏิเสธการอ้างสิทธิ์",
"vq.rejectHint": "โปรดระบุเหตุผลสั้นๆ เหตุผลนี้จะถูกส่งต่อให้ผู้ยื่นอ้างสิทธิ์",
"vq.rejectNoMatch": "คำตอบไม่ตรงกัน",
"vq.rejectVague": "คำอธิบายคลุมเครือเกินไป",
"vq.rejectReturned": "คืนสิ่งของไปแล้ว",
"vq.rejectOther": "อื่นๆ",
"vq.rejectOtherPh": "โปรดระบุเหตุผล…",
"vq.rejectConfirm": "ยืนยันการปฏิเสธ",
"fd.title": "โปรดทราบ",
"fd.text": "การแจ้งข้อมูลอันเป็นเท็จอาจส่งผลให้บัญชี Findloop ของคุณถูกระงับ หรืออาจถูกลบอย่างถาวร",
"fd.continue": "ฉันเข้าใจแล้ว ดำเนินการต่อ",
"fd.cancel": "ยกเลิก",
"fr.already": "คุณได้แจ้งแล้วว่าพบสิ่งของชิ้นนี้ การแจ้งของคุณกำลังอยู่ระหว่างการดำเนินการ",
"fr.photoLabel": "รูปถ่ายของสิ่งของที่พบ",
"fr.photoHint": "รูปนี้จะแสดงให้เจ้าของดูเพื่อให้ยืนยันว่าเป็นสิ่งของของเขาจริง",
"fr.photoError": "กรุณาเพิ่มรูปถ่ายของสิ่งของที่พบ",
"fr.isItYours": "นี่คือสิ่งของของคุณใช่ไหม?",
"fr.isItYoursHint": "ผู้พบได้ส่งรูปด้านล่างมาให้ หากเป็นสิ่งของของคุณ โปรดอธิบายจุดสังเกตพิเศษบางอย่างเพื่อพิสูจน์",
"fr.yesMine": "ใช่ นี่คือสิ่งของของฉัน",
"fr.notMine": "นี่ไม่ใช่สิ่งของของฉัน",
"fr.stPending": "ผู้พบกำลังตรวจสอบคำอธิบายของคุณ",
"fr.stRejected": "ลักษณะเฉพาะไม่ได้รับการยืนยัน",
"fr.stApproved": "ผู้พบยืนยันแล้ว",
"fr.proveTitle": "พิสูจน์ว่านี่คือสิ่งของของคุณ",
"fr.proveHint": "อธิบายลักษณะเฉพาะที่มีเพียงเจ้าของเท่านั้นที่รู้: สี ยี่ห้อ การสลัก สิ่งของข้างใน ตำหนิที่มองเห็นได้… ผู้พบจะยืนยันว่าตรงกันหรือไม่",
"fr.sent": "ส่งคำอธิบายไปยังผู้พบแล้ว คุณจะได้รับการแจ้งเตือนเมื่อมีการตอบกลับ",
"fr.approvedTitle": "ผู้พบยืนยันคำอธิบายของคุณแล้ว",
"fr.approvedHint": "ชำระค่าธรรมเนียมการรับคืนเพื่อรับข้อมูลติดต่อของเขา",
"fr.photoAlt": "รูปถ่ายที่ส่งโดยผู้พบ",
"fd.textFound": "การแจ้งข้อมูลอันเป็นเท็จถือเป็นการฉ้อโกงและอาจถูกดำเนินคดีตามกฎหมายที่ใช้บังคับในประเทศของคุณ",
"rp.otherPh": "โปรดระบุเหตุผลของการรายงาน…",
"rp.otherRequired": "โปรดระบุเหตุผลของการรายงาน",
"mc.cancelClaim": "ยกเลิกการเรียกร้องของฉัน",
"mc.cancelClaimDone": "การเรียกร้องของคุณถูกยกเลิกแล้ว",
"mc.cancelClaimConfirm": "คุณแน่ใจหรือไม่ว่าต้องการยกเลิกการเคลมของคุณ?",
"mc.confirm": "ยืนยัน",
"mc.cancel": "ยกเลิก",
"mc.stDeposited": "ฝากไว้",
"mc.stClaimed": "เคลมแล้ว",
"mc.stReturned": "ส่งคืนแล้ว",
"mc.progress": "ความคืบหน้า"
},
"vi": {
"vq.title": "Câu hỏi xác minh danh tính",
"vq.optional": "(tùy chọn — khuyến nghị)",
"vq.hint": "Đặt từ 1 đến 3 câu hỏi mà chỉ chủ sở hữu thật sự mới biết câu trả lời (ví dụ: màu của một chi tiết, nội dung, dấu hiệu đặc biệt). Không bao giờ hiển thị công khai.",
"vq.hintDeposit": "Đặt từ 1 đến 3 câu hỏi mà chỉ chủ sở hữu thật sự mới biết câu trả lời (ví dụ: màu của một chi tiết, nội dung, dấu hiệu đặc biệt). Chúng sẽ được dùng để xác thực một yêu cầu nhận lại. Không bao giờ hiển thị công khai.",
"vq.question": "Câu hỏi {n}",
"vq.optionalSuffix": "(không bắt buộc)",
"vq.noneWarning": "Chưa thêm câu hỏi nào. Chúng tôi khuyên bạn nên điền ít nhất một câu để bảo đảm việc hoàn trả và tránh các yêu cầu giả mạo.",
"vq.registryRef": "Tham chiếu để xác minh chủ sở hữu khi hoàn trả — không bao giờ hiển thị công khai.",
"vq.answersIntroQ": "Để tránh các yêu cầu giả mạo, hãy trả lời các câu hỏi bên dưới (màu của một chi tiết, thương hiệu, nội dung, dấu hiệu đặc biệt). Câu trả lời của bạn không hiển thị công khai cũng như trên tin đăng.",
"vq.answersIntroFree": "Để tránh các yêu cầu giả mạo, hãy mô tả 2 đến 3 đặc điểm chính xác của đồ vật (màu của một chi tiết, thương hiệu, nội dung, dấu hiệu đặc biệt). Câu trả lời của bạn không hiển thị công khai cũng như trên tin đăng.",
"vq.characteristic": "Đặc điểm {n}",
"vq.answerPh": "Câu trả lời của bạn…",
"vq.charPh": "Ví dụ: vết xước ở góc dưới bên phải",
"vq.sending": "Đang gửi…",
"vq.submit": "Gửi xác minh của tôi",
"vq.cancel": "Hủy",
"vq.rejectTitle": "Từ chối yêu cầu nhận lại",
"vq.rejectHint": "Vui lòng nêu ngắn gọn lý do. Lý do này sẽ được gửi cho người yêu cầu.",
"vq.rejectNoMatch": "Các câu trả lời không khớp",
"vq.rejectVague": "Mô tả quá mơ hồ",
"vq.rejectReturned": "Đồ vật đã được hoàn trả",
"vq.rejectOther": "Khác",
"vq.rejectOtherPh": "Nêu rõ lý do…",
"vq.rejectConfirm": "Xác nhận từ chối",
"fd.title": "Lưu ý",
"fd.text": "Mọi khai báo sai sự thật có thể dẫn đến việc tài khoản Findloop của bạn bị tạm ngưng, thậm chí bị xóa vĩnh viễn.",
"fd.continue": "Tôi hiểu, tiếp tục",
"fd.cancel": "Hủy",
"fr.already": "Bạn đã báo rằng mình đã tìm thấy đồ vật này. Khai báo của bạn đang được xử lý.",
"fr.photoLabel": "Ảnh của đồ vật nhặt được",
"fr.photoHint": "Ảnh này sẽ được hiển thị cho chủ sở hữu để họ xác nhận đó đúng là đồ vật của mình.",
"fr.photoError": "Hãy thêm ảnh của đồ vật nhặt được.",
"fr.isItYours": "Đây có đúng là đồ vật của bạn không?",
"fr.isItYoursHint": "Một người nhặt được đã gửi ảnh bên dưới. Nếu đó là đồ vật của bạn, hãy mô tả một vài dấu hiệu đặc biệt để chứng minh.",
"fr.yesMine": "Vâng, đó là đồ vật của tôi",
"fr.notMine": "Đó không phải là đồ vật của tôi",
"fr.stPending": "Người nhặt được đang kiểm tra mô tả của bạn",
"fr.stRejected": "Đặc điểm chưa được xác nhận",
"fr.stApproved": "Đã được người nhặt được xác nhận",
"fr.proveTitle": "Chứng minh đó là đồ vật của bạn",
"fr.proveHint": "Mô tả những đặc điểm mà chỉ chủ sở hữu mới biết: màu sắc, thương hiệu, khắc chữ, nội dung, khuyết điểm nhìn thấy được… Người nhặt được sẽ xác nhận xem chúng có khớp hay không.",
"fr.sent": "Mô tả đã được gửi cho người nhặt được. Bạn sẽ được thông báo về phản hồi của họ.",
"fr.approvedTitle": "Người nhặt được đã xác nhận mô tả của bạn",
"fr.approvedHint": "Thanh toán phí nhận lại để nhận thông tin liên hệ của họ.",
"fr.photoAlt": "Ảnh do người nhặt được gửi",
"fd.textFound": "Mọi khai báo gian dối đều cấu thành hành vi gian lận và có thể bị truy cứu trách nhiệm pháp lý theo quy định pháp luật hiện hành tại quốc gia của bạn.",
"rp.otherPh": "Vui lòng nêu rõ lý do báo cáo…",
"rp.otherRequired": "Vui lòng nêu rõ lý do báo cáo.",
"mc.cancelClaim": "Hủy yêu cầu khiếu nại của tôi",
"mc.cancelClaimDone": "Yêu cầu khiếu nại của bạn đã được hủy.",
"mc.cancelClaimConfirm": "Bạn có chắc chắn muốn hủy yêu cầu nhận lại của mình không?",
"mc.confirm": "Xác nhận",
"mc.cancel": "Hủy",
"mc.stDeposited": "Đã nộp",
"mc.stClaimed": "Đã yêu cầu nhận lại",
"mc.stReturned": "Đã trả lại",
"mc.progress": "Tiến trình"
},
"el": {
"vq.title": "Ερωτήσεις επαλήθευσης ταυτότητας",
"vq.optional": "(προαιρετικό — συνιστάται)",
"vq.hint": "Κάντε 1 έως 3 ερωτήσεις των οποίων την απάντηση γνωρίζει μόνο ο πραγματικός ιδιοκτήτης (π.χ. χρώμα μιας λεπτομέρειας, περιεχόμενο, ιδιαίτερο γνώρισμα). Δεν εμφανίζονται ποτέ δημόσια.",
"vq.hintDeposit": "Κάντε 1 έως 3 ερωτήσεις των οποίων την απάντηση γνωρίζει μόνο ο πραγματικός ιδιοκτήτης (π.χ. χρώμα μιας λεπτομέρειας, περιεχόμενο, ιδιαίτερο γνώρισμα). Θα χρησιμοποιηθούν για την επικύρωση μιας διεκδίκησης. Δεν εμφανίζονται ποτέ δημόσια.",
"vq.question": "Ερώτηση {n}",
"vq.optionalSuffix": "(προαιρετική)",
"vq.noneWarning": "Δεν προστέθηκε καμία ερώτηση. Σας συνιστούμε να συμπληρώσετε τουλάχιστον μία για να διασφαλιστεί η επιστροφή και να αποφευχθούν ψευδείς διεκδικήσεις.",
"vq.registryRef": "Αναφορά για την επαλήθευση του ιδιοκτήτη κατά την επιστροφή — δεν εμφανίζεται ποτέ δημόσια.",
"vq.answersIntroQ": "Για να αποφευχθούν οι ψευδείς διεκδικήσεις, απαντήστε στις παρακάτω ερωτήσεις (χρώμα μιας λεπτομέρειας, μάρκα, περιεχόμενο, ιδιαίτερο γνώρισμα). Οι απαντήσεις σας δεν είναι ορατές ούτε δημόσια ούτε στην αγγελία.",
"vq.answersIntroFree": "Για να αποφευχθούν οι ψευδείς διεκδικήσεις, περιγράψτε 2 έως 3 ακριβή χαρακτηριστικά του αντικειμένου (χρώμα μιας λεπτομέρειας, μάρκα, περιεχόμενο, ιδιαίτερο γνώρισμα). Οι απαντήσεις σας δεν είναι ορατές ούτε δημόσια ούτε στην αγγελία.",
"vq.characteristic": "Χαρακτηριστικό {n}",
"vq.answerPh": "Η απάντησή σας…",
"vq.charPh": "Π.χ. γρατζουνιά στην κάτω δεξιά γωνία",
"vq.sending": "Αποστολή…",
"vq.submit": "Αποστολή της επαλήθευσής μου",
"vq.cancel": "Ακύρωση",
"vq.rejectTitle": "Απόρριψη της διεκδίκησης",
"vq.rejectHint": "Αναφέρετε σύντομα τον λόγο. Αυτή η αιτιολογία θα διαβιβαστεί στον διεκδικητή.",
"vq.rejectNoMatch": "Οι απαντήσεις δεν αντιστοιχούν",
"vq.rejectVague": "Η περιγραφή είναι πολύ αόριστη",
"vq.rejectReturned": "Το αντικείμενο έχει ήδη επιστραφεί",
"vq.rejectOther": "Άλλο",
"vq.rejectOtherPh": "Διευκρινίστε τον λόγο…",
"vq.rejectConfirm": "Επιβεβαίωση απόρριψης",
"fd.title": "Προσοχή",
"fd.text": "Κάθε ψευδής δήλωση μπορεί να οδηγήσει σε αναστολή ή ακόμη και οριστική διαγραφή του λογαριασμού σας στο Findloop.",
"fd.continue": "Κατανοώ, συνέχεια",
"fd.cancel": "Ακύρωση",
"fr.already": "Έχετε ήδη δηλώσει ότι βρήκατε αυτό το αντικείμενο. Η δήλωσή σας βρίσκεται σε επεξεργασία.",
"fr.photoLabel": "Φωτογραφία του αντικειμένου που βρέθηκε",
"fr.photoHint": "Θα εμφανιστεί στον ιδιοκτήτη ώστε να επιβεβαιώσει ότι πρόκειται πράγματι για το αντικείμενό του.",
"fr.photoError": "Προσθέστε μια φωτογραφία του αντικειμένου που βρέθηκε.",
"fr.isItYours": "Είναι πράγματι δικό σας αντικείμενο;",
"fr.isItYoursHint": "Ένας ευρέτης έστειλε την παρακάτω φωτογραφία. Αν είναι το αντικείμενό σας, περιγράψτε μερικά ιδιαίτερα γνωρίσματα για να το αποδείξετε.",
"fr.yesMine": "Ναι, είναι το αντικείμενό μου",
"fr.notMine": "Δεν είναι το αντικείμενό μου",
"fr.stPending": "Ο ευρέτης ελέγχει την περιγραφή σας",
"fr.stRejected": "Τα χαρακτηριστικά δεν επιβεβαιώθηκαν",
"fr.stApproved": "Επιβεβαιώθηκε από τον ευρέτη",
"fr.proveTitle": "Αποδείξτε ότι είναι το αντικείμενό σας",
"fr.proveHint": "Περιγράψτε χαρακτηριστικά που γνωρίζει μόνο ο ιδιοκτήτης: χρώμα, μάρκα, χάραξη, περιεχόμενο, ορατό ελάττωμα… Ο ευρέτης θα επιβεβαιώσει αν αντιστοιχούν.",
"fr.sent": "Η περιγραφή στάλθηκε στον ευρέτη. Θα ειδοποιηθείτε για την απάντησή του.",
"fr.approvedTitle": "Ο ευρέτης επιβεβαίωσε την περιγραφή σας",
"fr.approvedHint": "Πληρώστε τα έξοδα ανάκτησης για να λάβετε τα στοιχεία επικοινωνίας του.",
"fr.photoAlt": "Φωτογραφία που έστειλε ο ευρέτης",
"fd.textFound": "Κάθε ψευδής δήλωση συνιστά απάτη και επισύρει δικαστική δίωξη σύμφωνα με την ισχύουσα νομοθεσία της χώρας σας.",
"rp.otherPh": "Διευκρινίστε τον λόγο της αναφοράς…",
"rp.otherRequired": "Διευκρινίστε τον λόγο της αναφοράς.",
"mc.cancelClaim": "Ακύρωση της αξίωσής μου",
"mc.cancelClaimDone": "Η αξίωσή σας ακυρώθηκε.",
"mc.cancelClaimConfirm": "Είστε βέβαιοι ότι θέλετε να ακυρώσετε την αξίωσή σας;",
"mc.confirm": "Επιβεβαίωση",
"mc.cancel": "Ακύρωση",
"mc.stDeposited": "Κατατέθηκε",
"mc.stClaimed": "Διεκδικήθηκε",
"mc.stReturned": "Επεστράφη",
"mc.progress": "Πρόοδος"
},
"sv": {
"vq.title": "Frågor för identitetsverifiering",
"vq.optional": "(valfritt — rekommenderas)",
"vq.hint": "Ställ 1 till 3 frågor som bara den riktiga ägaren känner svaret på (t.ex. färgen på en detalj, innehåll, särskilt kännetecken). Visas aldrig offentligt.",
"vq.hintDeposit": "Ställ 1 till 3 frågor som bara den riktiga ägaren känner svaret på (t.ex. färgen på en detalj, innehåll, särskilt kännetecken). De kommer att användas för att validera ett anspråk. Visas aldrig offentligt.",
"vq.question": "Fråga {n}",
"vq.optionalSuffix": "(valfri)",
"vq.noneWarning": "Inga frågor har lagts till. Vi rekommenderar att du fyller i minst en för att säkra återlämningen och undvika falska anspråk.",
"vq.registryRef": "Referens för att validera ägaren vid återlämningen — visas aldrig offentligt.",
"vq.answersIntroQ": "För att undvika falska anspråk, svara på frågorna nedan (färgen på en detalj, märke, innehåll, särskilt kännetecken). Dina svar är inte synliga offentligt eller i annonsen.",
"vq.answersIntroFree": "För att undvika falska anspråk, beskriv 2 till 3 exakta kännetecken för föremålet (färgen på en detalj, märke, innehåll, särskilt kännetecken). Dina svar är inte synliga offentligt eller i annonsen.",
"vq.characteristic": "Kännetecken {n}",
"vq.answerPh": "Ditt svar…",
"vq.charPh": "T.ex. repa i nedre högra hörnet",
"vq.sending": "Skickar…",
"vq.submit": "Skicka min verifiering",
"vq.cancel": "Avbryt",
"vq.rejectTitle": "Avvisa anspråket",
"vq.rejectHint": "Ange kort varför. Denna motivering kommer att skickas till den som gör anspråk.",
"vq.rejectNoMatch": "Svaren stämmer inte överens",
"vq.rejectVague": "Beskrivningen är för vag",
"vq.rejectReturned": "Föremålet har redan återlämnats",
"vq.rejectOther": "Annat",
"vq.rejectOtherPh": "Ange orsaken…",
"vq.rejectConfirm": "Bekräfta avvisning",
"fd.title": "Varning",
"fd.text": "Alla falska uppgifter kan leda till avstängning eller till och med permanent borttagning av ditt findloop-konto.",
"fd.continue": "Jag förstår, fortsätt",
"fd.cancel": "Avbryt",
"fr.already": "Du har redan anmält att du har hittat detta föremål. Din anmälan behandlas just nu.",
"fr.photoLabel": "Foto på det upphittade föremålet",
"fr.photoHint": "Det kommer att visas för ägaren så att hen kan bekräfta att det verkligen är hens föremål.",
"fr.photoError": "Lägg till ett foto på det upphittade föremålet.",
"fr.isItYours": "Är detta ditt föremål?",
"fr.isItYoursHint": "En upphittare har skickat bilden nedan. Om det är ditt föremål, beskriv några särskilda kännetecken för att bevisa det.",
"fr.yesMine": "Ja, det är mitt föremål",
"fr.notMine": "Det är inte mitt föremål",
"fr.stPending": "Upphittaren granskar din beskrivning",
"fr.stRejected": "Kännetecknen har inte bekräftats",
"fr.stApproved": "Bekräftat av upphittaren",
"fr.proveTitle": "Bevisa att det är ditt föremål",
"fr.proveHint": "Beskriv kännetecken som bara ägaren känner till: färg, märke, gravyr, innehåll, synlig skada… Upphittaren bekräftar om de stämmer.",
"fr.sent": "Beskrivningen har skickats till upphittaren. Du får en avisering om svaret.",
"fr.approvedTitle": "Upphittaren har bekräftat din beskrivning",
"fr.approvedHint": "Betala hämtningsavgiften för att få hens kontaktuppgifter.",
"fr.photoAlt": "Foto skickat av upphittaren",
"fd.textFound": "Alla falska uppgifter utgör bedrägeri och kan leda till rättsliga åtgärder enligt gällande lagstiftning i ditt land.",
"rp.otherPh": "Ange orsaken till anmälan…",
"rp.otherRequired": "Ange orsaken till anmälan.",
"mc.cancelClaim": "Avbryt min reklamation",
"mc.cancelClaimDone": "Din reklamation har avbrutits.",
"mc.cancelClaimConfirm": "Är du säker på att du vill avbryta din reklamation?",
"mc.confirm": "Bekräfta",
"mc.cancel": "Avbryt",
"mc.stDeposited": "Inlämnad",
"mc.stClaimed": "Hämtad",
"mc.stReturned": "Återlämnad",
"mc.progress": "Framsteg"
},
"da": {
"vq.title": "Spørgsmål til identitetsbekræftelse",
"vq.optional": "(valgfrit — anbefalet)",
"vq.hint": "Stil 1 til 3 spørgsmål, som kun den rette ejer kender svaret på (f.eks. farven på en detalje, indhold, særligt kendetegn). Aldrig synlige offentligt.",
"vq.hintDeposit": "Stil 1 til 3 spørgsmål, som kun den rette ejer kender svaret på (f.eks. farven på en detalje, indhold, særligt kendetegn). De bruges til at bekræfte et krav. Aldrig synlige offentligt.",
"vq.question": "Spørgsmål {n}",
"vq.optionalSuffix": "(valgfrit)",
"vq.noneWarning": "Ingen spørgsmål tilføjet. Vi anbefaler, at du angiver mindst ét for at sikre tilbageleveringen og undgå falske krav.",
"vq.registryRef": "Reference til at bekræfte ejeren ved tilbagelevering — aldrig synlig offentligt.",
"vq.answersIntroQ": "For at undgå falske krav, besvar spørgsmålene nedenfor (farven på en detalje, mærke, indhold, særligt kendetegn). Dine svar er hverken synlige offentligt eller på annoncen.",
"vq.answersIntroFree": "For at undgå falske krav, beskriv 2 til 3 præcise kendetegn ved genstanden (farven på en detalje, mærke, indhold, særligt kendetegn). Dine svar er hverken synlige offentligt eller på annoncen.",
"vq.characteristic": "Kendetegn {n}",
"vq.answerPh": "Dit svar…",
"vq.charPh": "F.eks. ridse på nederste højre hjørne",
"vq.sending": "Sender…",
"vq.submit": "Send min bekræftelse",
"vq.cancel": "Annuller",
"vq.rejectTitle": "Afvis kravet",
"vq.rejectHint": "Angiv kort hvorfor. Denne begrundelse bliver sendt til den, der gør kravet gældende.",
"vq.rejectNoMatch": "Svarene stemmer ikke overens",
"vq.rejectVague": "Beskrivelsen er for vag",
"vq.rejectReturned": "Genstanden er allerede tilbageleveret",
"vq.rejectOther": "Andet",
"vq.rejectOtherPh": "Præciser begrundelsen…",
"vq.rejectConfirm": "Bekræft afvisning",
"fd.title": "Bemærk",
"fd.text": "Enhver falsk erklæring kan medføre suspension eller endda permanent sletning af din findloop-konto.",
"fd.continue": "Jeg forstår, fortsæt",
"fd.cancel": "Annuller",
"fr.already": "Du har allerede meldt, at du har fundet denne genstand. Din anmeldelse er under behandling.",
"fr.photoLabel": "Foto af den fundne genstand",
"fr.photoHint": "Det vil blive vist til ejeren, så vedkommende kan bekræfte, at det faktisk er deres genstand.",
"fr.photoError": "Tilføj et foto af den fundne genstand.",
"fr.isItYours": "Er det din genstand?",
"fr.isItYoursHint": "En finder har sendt billedet nedenfor. Hvis det er din genstand, så beskriv nogle særlige kendetegn for at bevise det.",
"fr.yesMine": "Ja, det er min genstand",
"fr.notMine": "Det er ikke min genstand",
"fr.stPending": "Finderen kontrollerer din beskrivelse",
"fr.stRejected": "Kendetegn ikke bekræftet",
"fr.stApproved": "Bekræftet af finderen",
"fr.proveTitle": "Bevis, at det er din genstand",
"fr.proveHint": "Beskriv kendetegn, som kun ejeren kender: farve, mærke, gravering, indhold, synlig fejl… Finderen bekræfter, om de stemmer overens.",
"fr.sent": "Beskrivelsen er sendt til finderen. Du vil blive underrettet om svaret.",
"fr.approvedTitle": "Finderen har bekræftet din beskrivelse",
"fr.approvedHint": "Betal afhentningsgebyret for at få vedkommendes kontaktoplysninger.",
"fr.photoAlt": "Foto sendt af finderen",
"fd.textFound": "Enhver falsk erklæring udgør svig og kan retsforfølges i henhold til gældende lovgivning i dit land.",
"rp.otherPh": "Angiv årsagen til anmeldelsen…",
"rp.otherRequired": "Angiv årsagen til anmeldelsen.",
"mc.cancelClaim": "Annuller mit krav",
"mc.cancelClaimDone": "Dit krav er blevet annulleret.",
"mc.cancelClaimConfirm": "Er du sikker på, at du vil annullere din anmeldelse?",
"mc.confirm": "Bekræft",
"mc.cancel": "Annuller",
"mc.stDeposited": "Indleveret",
"mc.stClaimed": "Gjort krav på",
"mc.stReturned": "Returneret",
"mc.progress": "Fremskridt"
},
"fi": {
"vq.title": "Henkilöllisyyden varmistuskysymykset",
"vq.optional": "(valinnainen — suositeltu)",
"vq.hint": "Esitä 1–3 kysymystä, joihin vain oikea omistaja tietää vastauksen (esim. jonkin yksityiskohdan väri, sisältö, erityismerkki). Ei koskaan julkisesti näkyvissä.",
"vq.hintDeposit": "Esitä 1–3 kysymystä, joihin vain oikea omistaja tietää vastauksen (esim. jonkin yksityiskohdan väri, sisältö, erityismerkki). Niitä käytetään vaatimuksen vahvistamiseen. Ei koskaan julkisesti näkyvissä.",
"vq.question": "Kysymys {n}",
"vq.optionalSuffix": "(valinnainen)",
"vq.noneWarning": "Kysymyksiä ei lisätty. Suosittelemme lisäämään vähintään yhden, jotta luovutus on turvallisempi ja väärät vaatimukset voidaan välttää.",
"vq.registryRef": "Viite omistajan vahvistamiseen luovutuksen yhteydessä — ei koskaan julkisesti näkyvissä.",
"vq.answersIntroQ": "Väärien vaatimusten välttämiseksi vastaa alla oleviin kysymyksiin (jonkin yksityiskohdan väri, merkki, sisältö, erityismerkki). Vastauksesi eivät näy julkisesti eivätkä ilmoituksessa.",
"vq.answersIntroFree": "Väärien vaatimusten välttämiseksi kuvaile esineestä 2–3 tarkkaa ominaisuutta (jonkin yksityiskohdan väri, merkki, sisältö, erityismerkki). Vastauksesi eivät näy julkisesti eivätkä ilmoituksessa.",
"vq.characteristic": "Ominaisuus {n}",
"vq.answerPh": "Vastauksesi…",
"vq.charPh": "Esim. naarmu oikeassa alakulmassa",
"vq.sending": "Lähetetään…",
"vq.submit": "Lähetä vahvistukseni",
"vq.cancel": "Peruuta",
"vq.rejectTitle": "Hylkää vaatimus",
"vq.rejectHint": "Kerro lyhyesti miksi. Tämä syy välitetään vaatijalle.",
"vq.rejectNoMatch": "Vastaukset eivät täsmää",
"vq.rejectVague": "Kuvaus on liian epämääräinen",
"vq.rejectReturned": "Esine on jo palautettu",
"vq.rejectOther": "Muu",
"vq.rejectOtherPh": "Tarkenna syy…",
"vq.rejectConfirm": "Vahvista hylkäys",
"fd.title": "Huomio",
"fd.text": "Kaikki väärät ilmoitukset voivat johtaa findloop-tilisi keskeyttämiseen tai jopa pysyvään poistamiseen.",
"fd.continue": "Ymmärrän, jatka",
"fd.cancel": "Peruuta",
"fr.already": "Olet jo ilmoittanut löytäneesi tämän esineen. Ilmoitustasi käsitellään parhaillaan.",
"fr.photoLabel": "Kuva löydetystä esineestä",
"fr.photoHint": "Se näytetään omistajalle, jotta hän voi vahvistaa, että kyseessä on todella hänen esineensä.",
"fr.photoError": "Lisää kuva löydetystä esineestä.",
"fr.isItYours": "Onko tämä sinun esineesi?",
"fr.isItYoursHint": "Löytäjä on lähettänyt alla olevan kuvan. Jos tämä on sinun esineesi, kuvaile muutamia erityispiirteitä todistaaksesi sen.",
"fr.yesMine": "Kyllä, se on minun esineeni",
"fr.notMine": "Tämä ei ole minun esineeni",
"fr.stPending": "Löytäjä tarkistaa kuvauksesi",
"fr.stRejected": "Ominaisuuksia ei vahvistettu",
"fr.stApproved": "Löytäjä vahvisti",
"fr.proveTitle": "Todista, että tämä on sinun esineesi",
"fr.proveHint": "Kuvaile ominaisuuksia, jotka vain omistaja tietää: väri, merkki, kaiverrus, sisältö, näkyvä vika… Löytäjä vahvistaa, vastaavatko ne toisiaan.",
"fr.sent": "Kuvaus lähetettiin löytäjälle. Saat ilmoituksen hänen vastauksestaan.",
"fr.approvedTitle": "Löytäjä vahvisti kuvauksesi",
"fr.approvedHint": "Maksa noutokulut saadaksesi hänen yhteystietonsa.",
"fr.photoAlt": "Löytäjän lähettämä kuva",
"fd.textFound": "Kaikki väärät ilmoitukset katsotaan petokseksi, josta voidaan nostaa kanne maassasi voimassa olevan lainsäädännön mukaisesti.",
"rp.otherPh": "Tarkenna ilmoituksen syy…",
"rp.otherRequired": "Tarkenna ilmoituksen syy.",
"mc.cancelClaim": "Peruuta reklamaationi",
"mc.cancelClaimDone": "Reklamaatiosi on peruutettu.",
"mc.cancelClaimConfirm": "Haluatko varmasti peruuttaa vaatimuksesi?",
"mc.confirm": "Vahvista",
"mc.cancel": "Peruuta",
"mc.stDeposited": "Jätetty",
"mc.stClaimed": "Lunastettu",
"mc.stReturned": "Palautettu",
"mc.progress": "Edistyminen"
},
"no": {
"vq.title": "Spørsmål for identitetsbekreftelse",
"vq.optional": "(valgfritt — anbefalt)",
"vq.hint": "Still 1 til 3 spørsmål som bare den ekte eieren kjenner svaret på (f.eks. fargen på en detalj, innhold, særtrekk). Aldri synlige offentlig.",
"vq.hintDeposit": "Still 1 til 3 spørsmål som bare den ekte eieren kjenner svaret på (f.eks. fargen på en detalj, innhold, særtrekk). De vil bli brukt til å validere et krav. Aldri synlige offentlig.",
"vq.question": "Spørsmål {n}",
"vq.optionalSuffix": "(valgfritt)",
"vq.noneWarning": "Ingen spørsmål lagt til. Vi anbefaler at du fyller inn minst ett for å sikre tilbakeleveringen og unngå falske krav.",
"vq.registryRef": "Referanse for å validere eieren ved tilbakelevering — aldri synlig offentlig.",
"vq.answersIntroQ": "For å unngå falske krav, svar på spørsmålene nedenfor (fargen på en detalj, merke, innhold, særtrekk). Svarene dine er ikke synlige verken offentlig eller i annonsen.",
"vq.answersIntroFree": "For å unngå falske krav, beskriv 2 til 3 presise kjennetegn ved gjenstanden (fargen på en detalj, merke, innhold, særtrekk). Svarene dine er ikke synlige verken offentlig eller i annonsen.",
"vq.characteristic": "Kjennetegn {n}",
"vq.answerPh": "Ditt svar…",
"vq.charPh": "F.eks. ripe på nedre høyre hjørne",
"vq.sending": "Sender…",
"vq.submit": "Send inn bekreftelsen min",
"vq.cancel": "Avbryt",
"vq.rejectTitle": "Avvis kravet",
"vq.rejectHint": "Oppgi kort hvorfor. Denne begrunnelsen vil bli sendt til den som fremmer kravet.",
"vq.rejectNoMatch": "Svarene stemmer ikke overens",
"vq.rejectVague": "Beskrivelsen er for vag",
"vq.rejectReturned": "Gjenstanden er allerede tilbakelevert",
"vq.rejectOther": "Annet",
"vq.rejectOtherPh": "Presiser begrunnelsen…",
"vq.rejectConfirm": "Bekreft avvisning",
"fd.title": "Viktig",
"fd.text": "Enhver falsk erklæring kan føre til suspensjon eller permanent sletting av findloop-kontoen din.",
"fd.continue": "Jeg forstår, fortsett",
"fd.cancel": "Avbryt",
"fr.already": "Du har allerede meldt at du har funnet denne gjenstanden. Erklæringen din behandles.",
"fr.photoLabel": "Bilde av den funnede gjenstanden",
"fr.photoHint": "Det vil bli vist til eieren slik at vedkommende kan bekrefte at det faktisk er gjenstanden deres.",
"fr.photoError": "Legg til et bilde av den funnede gjenstanden.",
"fr.isItYours": "Er dette gjenstanden din?",
"fr.isItYoursHint": "En finner har sendt bildet nedenfor. Hvis det er gjenstanden din, beskriv noen særtrekk for å bevise det.",
"fr.yesMine": "Ja, det er gjenstanden min",
"fr.notMine": "Det er ikke gjenstanden min",
"fr.stPending": "Finneren kontrollerer beskrivelsen din",
"fr.stRejected": "Kjennetegn ikke bekreftet",
"fr.stApproved": "Bekreftet av finneren",
"fr.proveTitle": "Bevis at det er gjenstanden din",
"fr.proveHint": "Beskriv kjennetegn som bare eieren kjenner til: farge, merke, gravering, innhold, synlig feil… Finneren vil bekrefte om de stemmer.",
"fr.sent": "Beskrivelsen er sendt til finneren. Du vil bli varslet om svaret.",
"fr.approvedTitle": "Finneren har bekreftet beskrivelsen din",
"fr.approvedHint": "Betal hentekostnadene for å få kontaktopplysningene.",
"fr.photoAlt": "Bilde sendt av finneren",
"fd.textFound": "Enhver falsk erklæring utgjør bedrageri og kan føre til rettslig forfølgelse i henhold til gjeldende lovgivning i ditt land.",
"rp.otherPh": "Presiser årsaken til rapporteringen…",
"rp.otherRequired": "Presiser årsaken til rapporteringen.",
"mc.cancelClaim": "Avbryt min reklamasjon",
"mc.cancelClaimDone": "Reklamasjonen din er avbrutt.",
"mc.cancelClaimConfirm": "Er du sikker på at du vil avbryte kravet ditt?",
"mc.confirm": "Bekreft",
"mc.cancel": "Avbryt",
"mc.stDeposited": "Levert inn",
"mc.stClaimed": "Krevd",
"mc.stReturned": "Returnert",
"mc.progress": "Fremdrift"
},
"cs": {
"vq.title": "Ověřovací otázky totožnosti",
"vq.optional": "(volitelné — doporučeno)",
"vq.hint": "Položte 1 až 3 otázky, na které zná odpověď pouze skutečný vlastník (např. barva detailu, obsah, zvláštní znak). Nikdy nejsou veřejně viditelné.",
"vq.hintDeposit": "Položte 1 až 3 otázky, na které zná odpověď pouze skutečný vlastník (např. barva detailu, obsah, zvláštní znak). Budou sloužit k ověření nároku. Nikdy nejsou veřejně viditelné.",
"vq.question": "Otázka {n}",
"vq.optionalSuffix": "(volitelná)",
"vq.noneWarning": "Nebyla přidána žádná otázka. Doporučujeme vyplnit alespoň jednu, aby bylo předání bezpečnější a předešlo se falešným nárokům.",
"vq.registryRef": "Reference pro ověření vlastníka při předání — nikdy veřejně viditelná.",
"vq.answersIntroQ": "Abyste předešli falešným nárokům, odpovězte na níže uvedené otázky (barva detailu, značka, obsah, zvláštní znak). Vaše odpovědi nejsou viditelné ani veřejně, ani v inzerátu.",
"vq.answersIntroFree": "Abyste předešli falešným nárokům, popište 2 až 3 přesné vlastnosti předmětu (barva detailu, značka, obsah, zvláštní znak). Vaše odpovědi nejsou viditelné ani veřejně, ani v inzerátu.",
"vq.characteristic": "Vlastnost {n}",
"vq.answerPh": "Vaše odpověď…",
"vq.charPh": "Např. škrábanec v pravém dolním rohu",
"vq.sending": "Odesílání…",
"vq.submit": "Odeslat moje ověření",
"vq.cancel": "Zrušit",
"vq.rejectTitle": "Zamítnout nárok",
"vq.rejectHint": "Stručně uveďte proč. Tento důvod bude předán žadateli.",
"vq.rejectNoMatch": "Odpovědi neodpovídají",
"vq.rejectVague": "Popis je příliš vágní",
"vq.rejectReturned": "Předmět už byl vrácen",
"vq.rejectOther": "Jiné",
"vq.rejectOtherPh": "Upřesněte důvod…",
"vq.rejectConfirm": "Potvrdit zamítnutí",
"fd.title": "Upozornění",
"fd.text": "Jakékoli nepravdivé prohlášení může vést k pozastavení nebo dokonce k trvalému zrušení vašeho účtu findloop.",
"fd.continue": "Rozumím, pokračovat",
"fd.cancel": "Zrušit",
"fr.already": "Už jste nahlásili, že jste tento předmět našli. Vaše oznámení se zpracovává.",
"fr.photoLabel": "Fotografie nalezeného předmětu",
"fr.photoHint": "Bude ukázána vlastníkovi, aby potvrdil, že jde skutečně o jeho předmět.",
"fr.photoError": "Přidejte fotografii nalezeného předmětu.",
"fr.isItYours": "Je to opravdu váš předmět?",
"fr.isItYoursHint": "Nálezce poslal níže uvedenou fotografii. Pokud je to váš předmět, popište několik zvláštních znaků, abyste to prokázali.",
"fr.yesMine": "Ano, je to můj předmět",
"fr.notMine": "Není to můj předmět",
"fr.stPending": "Nálezce ověřuje váš popis",
"fr.stRejected": "Vlastnosti nebyly potvrzeny",
"fr.stApproved": "Potvrzeno nálezcem",
"fr.proveTitle": "Prokažte, že je to váš předmět",
"fr.proveHint": "Popište vlastnosti, které zná jen vlastník: barva, značka, rytina, obsah, viditelná vada… Nálezce potvrdí, zda odpovídají.",
"fr.sent": "Popis byl odeslán nálezci. O jeho odpovědi budete informováni.",
"fr.approvedTitle": "Nálezce potvrdil váš popis",
"fr.approvedHint": "Zaplaťte poplatek za vyzvednutí, abyste získali jeho kontaktní údaje.",
"fr.photoAlt": "Fotografie zaslaná nálezcem",
"fd.textFound": "Jakékoli nepravdivé prohlášení představuje podvod, který může být podle právních předpisů platných ve vaší zemi stíhán soudně.",
"rp.otherPh": "Upřesněte důvod nahlášení…",
"rp.otherRequired": "Upřesněte důvod nahlášení.",
"mc.cancelClaim": "Zrušit mou reklamaci",
"mc.cancelClaimDone": "Vaše reklamace byla zrušena.",
"mc.cancelClaimConfirm": "Opravdu chcete zrušit svou reklamaci?",
"mc.confirm": "Potvrdit",
"mc.cancel": "Zrušit",
"mc.stDeposited": "Uloženo",
"mc.stClaimed": "Nárokováno",
"mc.stReturned": "Vráceno",
"mc.progress": "Průběh"
},
"ro": {
"vq.title": "Întrebări de verificare a identității",
"vq.optional": "(opțional — recomandat)",
"vq.hint": "Puneți 1 până la 3 întrebări al căror răspuns îl cunoaște doar adevăratul proprietar (ex. culoarea unui detaliu, conținut, semn distinctiv). Nu sunt niciodată vizibile public.",
"vq.hintDeposit": "Puneți 1 până la 3 întrebări al căror răspuns îl cunoaște doar adevăratul proprietar (ex. culoarea unui detaliu, conținut, semn distinctiv). Ele vor servi la validarea unei revendicări. Nu sunt niciodată vizibile public.",
"vq.question": "Întrebarea {n}",
"vq.optionalSuffix": "(opțională)",
"vq.noneWarning": "Nu a fost adăugată nicio întrebare. Vă recomandăm să completați cel puțin una pentru a securiza restituirea și a evita revendicările false.",
"vq.registryRef": "Referință pentru validarea proprietarului la restituire — niciodată vizibilă public.",
"vq.answersIntroQ": "Pentru a evita revendicările false, răspundeți la întrebările de mai jos (culoarea unui detaliu, marcă, conținut, semn distinctiv). Răspunsurile dvs. nu sunt vizibile nici public, nici în anunț.",
"vq.answersIntroFree": "Pentru a evita revendicările false, descrieți 2 până la 3 caracteristici precise ale obiectului (culoarea unui detaliu, marcă, conținut, semn distinctiv). Răspunsurile dvs. nu sunt vizibile nici public, nici în anunț.",
"vq.characteristic": "Caracteristica {n}",
"vq.answerPh": "Răspunsul dvs.…",
"vq.charPh": "Ex. zgârietură în colțul din dreapta jos",
"vq.sending": "Se trimite…",
"vq.submit": "Trimite verificarea mea",
"vq.cancel": "Anulează",
"vq.rejectTitle": "Respinge revendicarea",
"vq.rejectHint": "Indicați pe scurt motivul. Acest motiv va fi transmis solicitantului.",
"vq.rejectNoMatch": "Răspunsurile nu corespund",
"vq.rejectVague": "Descriere prea vagă",
"vq.rejectReturned": "Obiect deja restituit",
"vq.rejectOther": "Altul",
"vq.rejectOtherPh": "Precizați motivul…",
"vq.rejectConfirm": "Confirmă respingerea",
"fd.title": "Atenție",
"fd.text": "Orice declarație falsă poate duce la suspendarea sau chiar la ștergerea definitivă a contului dvs. Findloop.",
"fd.continue": "Am înțeles, continuă",
"fd.cancel": "Anulează",
"fr.already": "Ați semnalat deja că ați găsit acest obiect. Declarația dvs. este în curs de procesare.",
"fr.photoLabel": "Fotografie a obiectului găsit",
"fr.photoHint": "Va fi arătată proprietarului pentru ca acesta să confirme că este într-adevăr obiectul său.",
"fr.photoError": "Adăugați o fotografie a obiectului găsit.",
"fr.isItYours": "Este acesta obiectul dvs.?",
"fr.isItYoursHint": "Un găsitor a trimis fotografia de mai jos. Dacă este obiectul dvs., descrieți câteva semne distinctive pentru a dovedi acest lucru.",
"fr.yesMine": "Da, este obiectul meu",
"fr.notMine": "Nu este obiectul meu",
"fr.stPending": "Găsitorul vă verifică descrierea",
"fr.stRejected": "Caracteristici neconfirmate",
"fr.stApproved": "Confirmat de găsitor",
"fr.proveTitle": "Dovediți că este obiectul dvs.",
"fr.proveHint": "Descrieți caracteristici pe care doar proprietarul le cunoaște: culoare, marcă, gravură, conținut, defect vizibil… Găsitorul va confirma dacă se potrivesc.",
"fr.sent": "Descriere trimisă găsitorului. Veți fi notificat(ă) cu privire la răspunsul său.",
"fr.approvedTitle": "Găsitorul a confirmat descrierea dvs.",
"fr.approvedHint": "Plătiți taxele de recuperare pentru a obține datele sale de contact.",
"fr.photoAlt": "Fotografie trimisă de găsitor",
"fd.textFound": "Orice declarație falsă constituie o fraudă pasibilă de acțiuni în justiție conform legislației în vigoare din țara dumneavoastră.",
"rp.otherPh": "Precizați motivul raportării…",
"rp.otherRequired": "Precizați motivul raportării.",
"mc.cancelClaim": "Anulează reclamația mea",
"mc.cancelClaimDone": "Reclamația dumneavoastră a fost anulată.",
"mc.cancelClaimConfirm": "Sigur doriți să anulați revendicarea?",
"mc.confirm": "Confirmă",
"mc.cancel": "Anulează",
"mc.stDeposited": "Depus",
"mc.stClaimed": "Revendicat",
"mc.stReturned": "Returnat",
"mc.progress": "Progres"
},
"hu": {
"vq.title": "Személyazonosság-ellenőrző kérdések",
"vq.optional": "(opcionális — ajánlott)",
"vq.hint": "Tegyen fel 1–3 kérdést, amelyekre csak a valódi tulajdonos tudja a választ (pl. egy részlet színe, tartalom, megkülönböztető jel). Ezek soha nem láthatók nyilvánosan.",
"vq.hintDeposit": "Tegyen fel 1–3 kérdést, amelyekre csak a valódi tulajdonos tudja a választ (pl. egy részlet színe, tartalom, megkülönböztető jel). Ezek egy igénylés ellenőrzésére szolgálnak. Ezek soha nem láthatók nyilvánosan.",
"vq.question": "{n}. kérdés",
"vq.optionalSuffix": "(opcionális)",
"vq.noneWarning": "Nem adott hozzá kérdést. Javasoljuk, hogy adjon meg legalább egyet az átadás biztonságosabbá tétele és a hamis igénylések elkerülése érdekében.",
"vq.registryRef": "Hivatkozás a tulajdonos ellenőrzéséhez az átadáskor — soha nem látható nyilvánosan.",
"vq.answersIntroQ": "A hamis igénylések elkerülése érdekében válaszoljon az alábbi kérdésekre (egy részlet színe, márka, tartalom, megkülönböztető jel). Válaszai sem nyilvánosan, sem a hirdetésben nem láthatók.",
"vq.answersIntroFree": "A hamis igénylések elkerülése érdekében írjon le 2–3 pontos jellemzőt a tárgyról (egy részlet színe, márka, tartalom, megkülönböztető jel). Válaszai sem nyilvánosan, sem a hirdetésben nem láthatók.",
"vq.characteristic": "{n}. jellemző",
"vq.answerPh": "Az Ön válasza…",
"vq.charPh": "Pl. karcolás a jobb alsó sarokban",
"vq.sending": "Küldés…",
"vq.submit": "Ellenőrzésem elküldése",
"vq.cancel": "Mégse",
"vq.rejectTitle": "Az igénylés elutasítása",
"vq.rejectHint": "Röviden adja meg az okot. Ezt az indokot továbbítjuk az igénylőnek.",
"vq.rejectNoMatch": "A válaszok nem egyeznek",
"vq.rejectVague": "A leírás túl homályos",
"vq.rejectReturned": "A tárgyat már visszaszolgáltatták",
"vq.rejectOther": "Egyéb",
"vq.rejectOtherPh": "Adja meg az okot…",
"vq.rejectConfirm": "Elutasítás megerősítése",
"fd.title": "Figyelem",
"fd.text": "Bármilyen valótlan nyilatkozat az Ön findloop-fiókjának felfüggesztését, sőt végleges törlését is eredményezheti.",
"fd.continue": "Megértettem, folytatás",
"fd.cancel": "Mégse",
"fr.already": "Ön már jelezte, hogy megtalálta ezt a tárgyat. Bejelentése feldolgozás alatt áll.",
"fr.photoLabel": "A megtalált tárgy fényképe",
"fr.photoHint": "Ezt megmutatjuk a tulajdonosnak, hogy megerősítse, valóban az ő tárgyáról van szó.",
"fr.photoError": "Adjon hozzá egy fényképet a megtalált tárgyról.",
"fr.isItYours": "Ez az Ön tárgya?",
"fr.isItYoursHint": "Egy megtaláló elküldte az alábbi fényképet. Ha ez az Ön tárgya, írjon le néhány megkülönböztető jegyet ennek bizonyítására.",
"fr.yesMine": "Igen, ez az én tárgyam",
"fr.notMine": "Ez nem az én tárgyam",
"fr.stPending": "A megtaláló ellenőrzi az Ön leírását",
"fr.stRejected": "A jellemzők nincsenek megerősítve",
"fr.stApproved": "A megtaláló megerősítette",
"fr.proveTitle": "Bizonyítsa be, hogy ez az Ön tárgya",
"fr.proveHint": "Írjon le olyan jellemzőket, amelyeket csak a tulajdonos ismer: szín, márka, gravírozás, tartalom, látható hiba… A megtaláló megerősíti, hogy egyeznek-e.",
"fr.sent": "A leírást elküldtük a megtalálónak. Értesítést kap a válaszáról.",
"fr.approvedTitle": "A megtaláló megerősítette az Ön leírását",
"fr.approvedHint": "Fizesse ki az átvételi díjakat, hogy megkapja az elérhetőségeit.",
"fr.photoAlt": "A megtaláló által küldött fénykép",
"fd.textFound": "Bármilyen valótlan nyilatkozat csalásnak minősül, és az Ön országában hatályos jogszabályok szerint jogi eljárást vonhat maga után.",
"rp.otherPh": "Adja meg a bejelentés okát…",
"rp.otherRequired": "Adja meg a bejelentés okát.",
"mc.cancelClaim": "Igénylésem törlése",
"mc.cancelClaimDone": "Az igénylését töröltük.",
"mc.cancelClaimConfirm": "Biztosan vissza szeretné vonni az igénylését?",
"mc.confirm": "Megerősítés",
"mc.cancel": "Mégse",
"mc.stDeposited": "Leadva",
"mc.stClaimed": "Igényelve",
"mc.stReturned": "Visszaszolgáltatva",
"mc.progress": "Folyamat"
},
"sk": {
"vq.title": "Overovacie otázky identity",
"vq.optional": "(voliteľné — odporúčané)",
"vq.hint": "Položte 1 až 3 otázky, na ktoré pozná odpoveď iba skutočný vlastník (napr. farba detailu, obsah, zvláštne znamenie). Nikdy nie sú verejne viditeľné.",
"vq.hintDeposit": "Položte 1 až 3 otázky, na ktoré pozná odpoveď iba skutočný vlastník (napr. farba detailu, obsah, zvláštne znamenie). Budú slúžiť na overenie nároku. Nikdy nie sú verejne viditeľné.",
"vq.question": "Otázka {n}",
"vq.optionalSuffix": "(voliteľná)",
"vq.noneWarning": "Nebola pridaná žiadna otázka. Odporúčame vám vyplniť aspoň jednu, aby sa zabezpečilo vrátenie a predišlo sa falošným nárokom.",
"vq.registryRef": "Referencia na overenie vlastníka pri vrátení — nikdy nie je verejne viditeľná.",
"vq.answersIntroQ": "Aby sa predišlo falošným nárokom, odpovedzte na nižšie uvedené otázky (farba detailu, značka, obsah, zvláštne znamenie). Vaše odpovede nie sú viditeľné ani verejne, ani v inzeráte.",
"vq.answersIntroFree": "Aby sa predišlo falošným nárokom, opíšte 2 až 3 presné charakteristiky predmetu (farba detailu, značka, obsah, zvláštne znamenie). Vaše odpovede nie sú viditeľné ani verejne, ani v inzeráte.",
"vq.characteristic": "Charakteristika {n}",
"vq.answerPh": "Vaša odpoveď…",
"vq.charPh": "Napr. škrabanec v pravom dolnom rohu",
"vq.sending": "Odosielanie…",
"vq.submit": "Odoslať moje overenie",
"vq.cancel": "Zrušiť",
"vq.rejectTitle": "Zamietnuť nárok",
"vq.rejectHint": "Stručne uveďte dôvod. Toto odôvodnenie bude odoslané žiadateľovi.",
"vq.rejectNoMatch": "Odpovede sa nezhodujú",
"vq.rejectVague": "Príliš nejasný popis",
"vq.rejectReturned": "Predmet už bol vrátený",
"vq.rejectOther": "Iné",
"vq.rejectOtherPh": "Upresnite dôvod…",
"vq.rejectConfirm": "Potvrdiť zamietnutie",
"fd.title": "Pozor",
"fd.text": "Akékoľvek nepravdivé vyhlásenie môže viesť k pozastaveniu alebo dokonca k trvalému odstráneniu vášho účtu findloop.",
"fd.continue": "Rozumiem, pokračovať",
"fd.cancel": "Zrušiť",
"fr.already": "Už ste nahlásili, že ste našli tento predmet. Vaše oznámenie sa spracováva.",
"fr.photoLabel": "Fotografia nájdeného predmetu",
"fr.photoHint": "Bude zobrazená vlastníkovi, aby potvrdil, že ide naozaj o jeho predmet.",
"fr.photoError": "Pridajte fotografiu nájdeného predmetu.",
"fr.isItYours": "Je to naozaj váš predmet?",
"fr.isItYoursHint": "Nálezca poslal fotografiu nižšie. Ak je to váš predmet, opíšte niekoľko zvláštnych znakov, aby ste to dokázali.",
"fr.yesMine": "Áno, je to môj predmet",
"fr.notMine": "Toto nie je môj predmet",
"fr.stPending": "Nálezca overuje váš popis",
"fr.stRejected": "Charakteristiky neboli potvrdené",
"fr.stApproved": "Potvrdené nálezcom",
"fr.proveTitle": "Dokážte, že je to váš predmet",
"fr.proveHint": "Opíšte charakteristiky, ktoré pozná iba vlastník: farba, značka, rytina, obsah, viditeľná chyba… Nálezca potvrdí, či sa zhodujú.",
"fr.sent": "Popis bol odoslaný nálezcovi. O jeho odpovedi budete informovaní.",
"fr.approvedTitle": "Nálezca potvrdil váš popis",
"fr.approvedHint": "Uhraďte poplatky za vyzdvihnutie, aby ste získali jeho kontaktné údaje.",
"fr.photoAlt": "Fotografia odoslaná nálezcom",
"fd.textFound": "Akékoľvek nepravdivé vyhlásenie predstavuje podvod, za ktorý možno podľa právnych predpisov platných vo vašej krajine viesť súdne konanie.",
"rp.otherPh": "Spresnite dôvod nahlásenia…",
"rp.otherRequired": "Spresnite dôvod nahlásenia.",
"mc.cancelClaim": "Zrušiť moju žiadosť",
"mc.cancelClaimDone": "Vaša žiadosť bola zrušená.",
"mc.cancelClaimConfirm": "Naozaj chcete zrušiť svoju reklamáciu?",
"mc.confirm": "Potvrdiť",
"mc.cancel": "Zrušiť",
"mc.stDeposited": "Odovzdané",
"mc.stClaimed": "Nárokované",
"mc.stReturned": "Vrátené",
"mc.progress": "Priebeh"
},
"bg": {
"vq.title": "Въпроси за потвърждение на самоличността",
"vq.optional": "(по избор — препоръчително)",
"vq.hint": "Задайте от 1 до 3 въпроса, на които само истинският собственик знае отговора (напр. цвят на детайл, съдържание, отличителен белег). Никога не се виждат публично.",
"vq.hintDeposit": "Задайте от 1 до 3 въпроса, на които само истинският собственик знае отговора (напр. цвят на детайл, съдържание, отличителен белег). Те ще служат за потвърждаване на искане. Никога не се виждат публично.",
"vq.question": "Въпрос {n}",
"vq.optionalSuffix": "(по избор)",
"vq.noneWarning": "Не е добавен нито един въпрос. Препоръчваме ви да попълните поне един, за да осигурите безопасно връщане и да избегнете фалшиви искания.",
"vq.registryRef": "Референция за потвърждаване на собственика при връщането — никога не се вижда публично.",
"vq.answersIntroQ": "За да избегнете фалшиви искания, отговорете на въпросите по-долу (цвят на детайл, марка, съдържание, отличителен белег). Вашите отговори не се виждат нито публично, нито в обявата.",
"vq.answersIntroFree": "За да избегнете фалшиви искания, опишете 2 до 3 точни характеристики на предмета (цвят на детайл, марка, съдържание, отличителен белег). Вашите отговори не се виждат нито публично, нито в обявата.",
"vq.characteristic": "Характеристика {n}",
"vq.answerPh": "Вашият отговор…",
"vq.charPh": "Напр. драскотина в долния десен ъгъл",
"vq.sending": "Изпращане…",
"vq.submit": "Изпрати моята проверка",
"vq.cancel": "Отказ",
"vq.rejectTitle": "Отхвърляне на искането",
"vq.rejectHint": "Посочете накратко причината. Този мотив ще бъде изпратен на заявителя.",
"vq.rejectNoMatch": "Отговорите не съвпадат",
"vq.rejectVague": "Описанието е твърде неясно",
"vq.rejectReturned": "Предметът вече е върнат",
"vq.rejectOther": "Друго",
"vq.rejectOtherPh": "Уточнете причината…",
"vq.rejectConfirm": "Потвърди отхвърлянето",
"fd.title": "Внимание",
"fd.text": "Всяка невярна декларация може да доведе до временно спиране или дори до окончателно изтриване на вашия акаунт в Findloop.",
"fd.continue": "Разбирам, продължи",
"fd.cancel": "Отказ",
"fr.already": "Вече сте съобщили, че сте намерили този предмет. Вашата декларация се обработва.",
"fr.photoLabel": "Снимка на намерения предмет",
"fr.photoHint": "Тя ще бъде показана на собственика, за да потвърди, че това наистина е неговият предмет.",
"fr.photoError": "Добавете снимка на намерения предмет.",
"fr.isItYours": "Това вашият предмет ли е?",
"fr.isItYoursHint": "Намерилият е изпратил снимката по-долу. Ако това е вашият предмет, опишете няколко отличителни белега, за да го докажете.",
"fr.yesMine": "Да, това е моят предмет",
"fr.notMine": "Това не е моят предмет",
"fr.stPending": "Намерилият проверява вашето описание",
"fr.stRejected": "Характеристиките не са потвърдени",
"fr.stApproved": "Потвърдено от намерилия",
"fr.proveTitle": "Докажете, че това е вашият предмет",
"fr.proveHint": "Опишете характеристики, които само собственикът знае: цвят, марка, гравюра, съдържание, видим дефект… Намерилият ще потвърди дали съвпадат.",
"fr.sent": "Описанието е изпратено на намерилия. Ще бъдете уведомени за неговия отговор.",
"fr.approvedTitle": "Намерилият потвърди вашето описание",
"fr.approvedHint": "Платете таксите за получаване, за да получите неговите координати.",
"fr.photoAlt": "Снимка, изпратена от намерилия",
"fd.textFound": "Всяка невярна декларация представлява измама, която подлежи на съдебно преследване съгласно действащото законодателство във вашата страна.",
"rp.otherPh": "Уточнете причината за сигнала…",
"rp.otherRequired": "Уточнете причината за сигнала.",
"mc.cancelClaim": "Отменяне на моята претенция",
"mc.cancelClaimDone": "Вашата претенция беше отменена.",
"mc.cancelClaimConfirm": "Сигурни ли сте, че искате да отмените вашата претенция?",
"mc.confirm": "Потвърди",
"mc.cancel": "Отказ",
"mc.stDeposited": "Предаден",
"mc.stClaimed": "Заявен",
"mc.stReturned": "Върнат",
"mc.progress": "Напредък"
},
"hr": {
"vq.title": "Pitanja za provjeru identiteta",
"vq.optional": "(neobavezno — preporučeno)",
"vq.hint": "Postavite 1 do 3 pitanja na koja samo pravi vlasnik zna odgovor (npr. boja nekog detalja, sadržaj, posebna oznaka). Nikada nisu javno vidljiva.",
"vq.hintDeposit": "Postavite 1 do 3 pitanja na koja samo pravi vlasnik zna odgovor (npr. boja nekog detalja, sadržaj, posebna oznaka). Služit će za provjeru zahtjeva. Nikada nisu javno vidljiva.",
"vq.question": "Pitanje {n}",
"vq.optionalSuffix": "(neobavezno)",
"vq.noneWarning": "Nijedno pitanje nije dodano. Savjetujemo vam da unesete barem jedno kako biste osigurali povrat i izbjegli lažne zahtjeve.",
"vq.registryRef": "Referenca za potvrdu vlasnika prilikom povrata — nikada javno vidljiva.",
"vq.answersIntroQ": "Kako biste izbjegli lažne zahtjeve, odgovorite na pitanja u nastavku (boja nekog detalja, marka, sadržaj, posebna oznaka). Vaši odgovori nisu vidljivi ni javno ni u oglasu.",
"vq.answersIntroFree": "Kako biste izbjegli lažne zahtjeve, opišite 2 do 3 precizne karakteristike predmeta (boja nekog detalja, marka, sadržaj, posebna oznaka). Vaši odgovori nisu vidljivi ni javno ni u oglasu.",
"vq.characteristic": "Karakteristika {n}",
"vq.answerPh": "Vaš odgovor…",
"vq.charPh": "Npr. ogrebotina na donjem desnom kutu",
"vq.sending": "Slanje…",
"vq.submit": "Pošalji moju provjeru",
"vq.cancel": "Odustani",
"vq.rejectTitle": "Odbij zahtjev",
"vq.rejectHint": "Ukratko navedite zašto. Ovaj razlog bit će poslan podnositelju zahtjeva.",
"vq.rejectNoMatch": "Odgovori se ne podudaraju",
"vq.rejectVague": "Opis je previše nejasan",
"vq.rejectReturned": "Predmet je već vraćen",
"vq.rejectOther": "Drugo",
"vq.rejectOtherPh": "Navedite razlog…",
"vq.rejectConfirm": "Potvrdi odbijanje",
"fd.title": "Pažnja",
"fd.text": "Svaka lažna izjava može dovesti do suspenzije, pa čak i trajnog brisanja vašeg Findloop računa.",
"fd.continue": "Razumijem, nastavi",
"fd.cancel": "Odustani",
"fr.already": "Već ste prijavili da ste pronašli ovaj predmet. Vaša prijava se obrađuje.",
"fr.photoLabel": "Fotografija pronađenog predmeta",
"fr.photoHint": "Bit će prikazana vlasniku kako bi potvrdio da se doista radi o njegovom predmetu.",
"fr.photoError": "Dodajte fotografiju pronađenog predmeta.",
"fr.isItYours": "Je li ovo vaš predmet?",
"fr.isItYoursHint": "Pronalazač je poslao fotografiju ispod. Ako je to vaš predmet, opišite nekoliko posebnih obilježja kako biste to dokazali.",
"fr.yesMine": "Da, to je moj predmet",
"fr.notMine": "To nije moj predmet",
"fr.stPending": "Pronalazač provjerava vaš opis",
"fr.stRejected": "Karakteristike nisu potvrđene",
"fr.stApproved": "Potvrdio pronalazač",
"fr.proveTitle": "Dokažite da je to vaš predmet",
"fr.proveHint": "Opišite karakteristike koje zna samo vlasnik: boja, marka, gravura, sadržaj, vidljiv nedostatak… Pronalazač će potvrditi podudaraju li se.",
"fr.sent": "Opis je poslan pronalazaču. Bit ćete obaviješteni o njegovom odgovoru.",
"fr.approvedTitle": "Pronalazač je potvrdio vaš opis",
"fr.approvedHint": "Platite troškove preuzimanja kako biste dobili njegove kontakt podatke.",
"fr.photoAlt": "Fotografija koju je poslao pronalazač",
"fd.textFound": "Svaka lažna izjava predstavlja prijevaru podložnu sudskom progonu u skladu s važećim zakonodavstvom vaše zemlje.",
"rp.otherPh": "Navedite razlog prijave…",
"rp.otherRequired": "Navedite razlog prijave.",
"mc.cancelClaim": "Otkaži moj zahtjev",
"mc.cancelClaimDone": "Vaš zahtjev je otkazan.",
"mc.cancelClaimConfirm": "Jeste li sigurni da želite otkazati svoju reklamaciju?",
"mc.confirm": "Potvrdi",
"mc.cancel": "Odustani",
"mc.stDeposited": "Pohranjeno",
"mc.stClaimed": "Preuzeto",
"mc.stReturned": "Vraćeno",
"mc.progress": "Napredak"
},
"ca": {
"vq.title": "Preguntes de verificació d'identitat",
"vq.optional": "(opcional — recomanat)",
"vq.hint": "Feu d'1 a 3 preguntes de les quals només el veritable propietari en conegui la resposta (p. ex. color d'un detall, contingut, senyal particular). Mai visibles públicament.",
"vq.hintDeposit": "Feu d'1 a 3 preguntes de les quals només el veritable propietari en conegui la resposta (p. ex. color d'un detall, contingut, senyal particular). Serviran per validar una reclamació. Mai visibles públicament.",
"vq.question": "Pregunta {n}",
"vq.optionalSuffix": "(facultativa)",
"vq.noneWarning": "No s'ha afegit cap pregunta. Us aconsellem d'indicar-ne almenys una per assegurar la devolució i evitar reclamacions falses.",
"vq.registryRef": "Referència per validar el propietari durant la devolució — mai visible públicament.",
"vq.answersIntroQ": "Per evitar reclamacions falses, responeu les preguntes següents (color d'un detall, marca, contingut, senyal particular). Les vostres respostes no són visibles ni públicament ni a l'anunci.",
"vq.answersIntroFree": "Per evitar reclamacions falses, descriviu de 2 a 3 característiques precises de l'objecte (color d'un detall, marca, contingut, senyal particular). Les vostres respostes no són visibles ni públicament ni a l'anunci.",
"vq.characteristic": "Característica {n}",
"vq.answerPh": "La vostra resposta…",
"vq.charPh": "P. ex. ratllada a la cantonada inferior dreta",
"vq.sending": "Enviament…",
"vq.submit": "Envia la meva verificació",
"vq.cancel": "Cancel·la",
"vq.rejectTitle": "Rebutja la reclamació",
"vq.rejectHint": "Indiqueu breument el motiu. Aquest motiu es transmetrà al reclamant.",
"vq.rejectNoMatch": "Les respostes no coincideixen",
"vq.rejectVague": "Descripció massa vaga",
"vq.rejectReturned": "Objecte ja retornat",
"vq.rejectOther": "Altres",
"vq.rejectOtherPh": "Preciseu el motiu…",
"vq.rejectConfirm": "Confirma el rebuig",
"fd.title": "Atenció",
"fd.text": "Qualsevol declaració falsa pot comportar la suspensió, o fins i tot la supressió definitiva del vostre compte de findloop.",
"fd.continue": "Ho entenc, continua",
"fd.cancel": "Cancel·la",
"fr.already": "Ja heu indicat que heu trobat aquest objecte. La vostra declaració s'està tramitant.",
"fr.photoLabel": "Foto de l'objecte trobat",
"fr.photoHint": "Es mostrarà al propietari perquè confirmi que es tracta realment del seu objecte.",
"fr.photoError": "Afegiu una foto de l'objecte trobat.",
"fr.isItYours": "És realment el vostre objecte?",
"fr.isItYoursHint": "Una persona que l'ha trobat ha enviat la foto següent. Si és el vostre objecte, descriviu alguns senyals particulars per demostrar-ho.",
"fr.yesMine": "Sí, és el meu objecte",
"fr.notMine": "No és el meu objecte",
"fr.stPending": "La persona que l'ha trobat està verificant la vostra descripció",
"fr.stRejected": "Característiques no confirmades",
"fr.stApproved": "Confirmat per la persona que l'ha trobat",
"fr.proveTitle": "Demostreu que és el vostre objecte",
"fr.proveHint": "Descriviu característiques que només el propietari coneix: color, marca, gravat, contingut, defecte visible… La persona que l'ha trobat confirmarà si coincideixen.",
"fr.sent": "Descripció enviada a la persona que l'ha trobat. Se us notificarà la seva resposta.",
"fr.approvedTitle": "La persona que l'ha trobat ha confirmat la vostra descripció",
"fr.approvedHint": "Pagueu les despeses de recuperació per obtenir les seves dades de contacte.",
"fr.photoAlt": "Foto enviada per la persona que l'ha trobat",
"fd.textFound": "Qualsevol declaració falsa constitueix un frau susceptible de persecució judicial d'acord amb la legislació vigent al vostre país.",
"rp.otherPh": "Especifiqueu el motiu de la denúncia…",
"rp.otherRequired": "Especifiqueu el motiu de la denúncia.",
"mc.cancelClaim": "Cancel·lar la meva reclamació",
"mc.cancelClaimDone": "La vostra reclamació ha estat cancel·lada.",
"mc.cancelClaimConfirm": "Esteu segur que voleu cancel·lar la vostra reclamació?",
"mc.confirm": "Confirmar",
"mc.cancel": "Cancel·lar",
"mc.stDeposited": "Dipositat",
"mc.stClaimed": "Reclamat",
"mc.stReturned": "Retornat",
"mc.progress": "Progrés"
},
"fr": {
"vq.title": "Questions de vérification d'identité",
"vq.optional": "(optionnel — recommandé)",
"vq.hint": "Posez 1 à 3 questions dont seul le vrai propriétaire connaît la réponse (ex. couleur d'un détail, contenu, signe particulier). Jamais visibles publiquement.",
"vq.hintDeposit": "Posez 1 à 3 questions dont seul le vrai propriétaire connaît la réponse (ex. couleur d'un détail, contenu, signe particulier). Elles serviront à valider une réclamation. Jamais visibles publiquement.",
"vq.question": "Question {n}",
"vq.optionalSuffix": "(facultative)",
"vq.noneWarning": "Aucune question ajoutée. Nous vous conseillons d'en renseigner au moins une pour sécuriser la restitution et éviter les fausses réclamations.",
"vq.registryRef": "Référence pour valider le propriétaire lors de la restitution — jamais visible publiquement.",
"vq.answersIntroQ": "Pour éviter les fausses réclamations, répondez aux questions ci-dessous (couleur d'un détail, marque, contenu, signe particulier). Vos réponses ne sont visibles ni publiquement, ni sur l'annonce.",
"vq.answersIntroFree": "Pour éviter les fausses réclamations, décrivez 2 à 3 caractéristiques précises de l'objet (couleur d'un détail, marque, contenu, signe particulier). Vos réponses ne sont visibles ni publiquement, ni sur l'annonce.",
"vq.characteristic": "Caractéristique {n}",
"vq.answerPh": "Votre réponse…",
"vq.charPh": "Ex. rayure sur le coin inférieur droit",
"vq.sending": "Envoi…",
"vq.submit": "Envoyer ma vérification",
"vq.cancel": "Annuler",
"vq.rejectTitle": "Rejeter la réclamation",
"vq.rejectHint": "Indiquez brièvement pourquoi. Ce motif sera transmis au réclamant.",
"vq.rejectNoMatch": "Les réponses ne correspondent pas",
"vq.rejectVague": "Description trop vague",
"vq.rejectReturned": "Objet déjà restitué",
"vq.rejectOther": "Autre",
"vq.rejectOtherPh": "Précisez le motif…",
"vq.rejectConfirm": "Confirmer le rejet",
"fd.title": "Attention",
"fd.text": "Toute fausse déclaration pourra entraîner la suspension, voire la suppression définitive de votre compte findloop.",
"fd.continue": "Je comprends, continuer",
"fd.cancel": "Annuler",
"fr.already": "Vous avez déjà signalé avoir trouvé cet objet. Votre déclaration est en cours de traitement.",
"fr.photoLabel": "Photo de l'objet trouvé",
"fr.photoHint": "Elle sera montrée au propriétaire pour qu'il confirme qu'il s'agit bien de son objet.",
"fr.photoError": "Ajoutez une photo de l'objet trouvé.",
"fr.isItYours": "Est-ce bien votre objet ?",
"fr.isItYoursHint": "Un trouveur a envoyé la photo ci-dessous. Si c'est votre objet, décrivez quelques signes particuliers pour le prouver.",
"fr.yesMine": "Oui, c'est mon objet",
"fr.notMine": "Ce n'est pas mon objet",
"fr.stPending": "Le trouveur vérifie votre description",
"fr.stRejected": "Caractéristiques non confirmées",
"fr.stApproved": "Confirmé par le trouveur",
"fr.proveTitle": "Prouvez que c'est votre objet",
"fr.proveHint": "Décrivez des caractéristiques que seul le propriétaire connaît : couleur, marque, gravure, contenu, défaut visible… Le trouveur confirmera si elles correspondent.",
"fr.sent": "Description envoyée au trouveur. Vous serez notifié de sa réponse.",
"fr.approvedTitle": "Le trouveur a confirmé votre description",
"fr.approvedHint": "Réglez les frais de récupération pour obtenir ses coordonnées.",
"fr.photoAlt": "Photo envoyée par le trouveur",
"fd.textFound": "Toute fausse déclaration constitue une fraude passible de poursuites judiciaires selon la législation en vigueur dans votre pays.",
"rp.otherPh": "Précisez le motif du signalement…",
"rp.otherRequired": "Précisez le motif du signalement.",
"mc.cancelClaim": "Annuler ma réclamation",
"mc.cancelClaimDone": "Votre réclamation a été annulée.",
"mc.cancelClaimConfirm": "Êtes-vous sûr de vouloir annuler votre réclamation ?",
"mc.confirm": "Confirmer",
"mc.cancel": "Annuler",
"mc.stDeposited": "Déposé",
"mc.stClaimed": "Réclamé",
"mc.stReturned": "Restitué",
"mc.progress": "Progression"
}
};
